import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators,FormBuilder, FormArray, UntypedFormGroup, ValidatorFn,AbstractControl, ValidationErrors, UntypedFormArray} from '@angular/forms';
import { StructureTagService } from '../services/structureTag.service';
import { VerifyRuleName } from './verification/verify-rule-name';
import { VerifyIntelListName } from './verification/verify-intel_list-name';
import { RulenameValidator } from './verification/rulenameAsyncValidator';
import { IntelnameValidator } from './verification/intelnameAsyncValidator';
import { RuleService } from './rule-custom-service';
import { VerifyImpactedHost } from './verification/impacted-host-validator';
import { QueryEditorService } from '../language-service/query-editor.service';
import { SharedService } from '../services/shared.service';
import { Observable,Subject,BehaviorSubject,of } from 'rxjs';
import { EditorView } from 'codemirror';
import { environment } from 'src/environments/environment';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { distinctUntilChanged, takeLast, takeUntil } from 'rxjs/operators';
import { TimeZoneService } from '../services/time-zone.service';
import { formatDate } from '@angular/common';
import { QueryTokensProviderService } from'../language-service/query-tokens-provider.service';
import { AssetDropdownService } from '../shared/assets/assets-dropdown.service';

@Injectable()
export class RulevarService {

  constructor(
    private fb:FormBuilder,
    public ruleservice:RuleService,
    public sharedService:SharedService,
    private structureTagsService:StructureTagService,
    private queryEdtorService:QueryEditorService,
    private timezoneservice: TimeZoneService,
    private http: HttpClient,
    private querytokenprovider:QueryTokensProviderService,
    private assetsService:AssetDropdownService
  ) {

    this.sharedService.customerChanged_.subscribe(()=> this.resetUser());

    this.sharedService.$metaData.subscribe((metadata:any)=>{
      this.ruleMeta = metadata.rule;
      this.commonData = metadata.commonData;
      this.rulepreprocess();
    })

    this.sharedService.userLoggedoff_.subscribe(()=>{
      this.resetrulelist();
      this.resetrulefrom();
    })

  }
  ruleMeta: any = JSON.parse(JSON.stringify(this.sharedService.metaData.rule)) // MetaData
  listFields=[]
  platformfields=[]
  actionFields=[]
  totalFields=[]
  selectedFields=[]
  triggers_error:boolean=false
  queryVerified:boolean=false
  actionError:boolean=false
  timeError:boolean=false
  listFieldError:boolean=true
  actionListFields=[]
  // newtermLimit=60
  editState: boolean = false;
  // newtermLimit=JSON.parse(JSON.stringify(this.metaData.newtermLimit))
  totalPlatformFields=this.sharedService.commonPlatformFields

  phantomMode=false

  listDataTypeError={}

  entityList=[]

  isBuiltIn:boolean=false


  defaultPartitionsDisp =['Firewall.Fortinet.Fortigate.Traffic.LAN-DMZ.Allow']

  partitionsDisp=[]
  partitions

  defaultPartitions=[{
    "sub_type": "Allow",
    "technology": "Firewall",
    "event_class": "Traffic",
    "platform_id": 22,
    "model_device": "Fortigate",
    "platform_desc": "firewall_fortigate",
    "platform_disp": "Fortigate Firewall",
    "partition_name": "Firewall.Fortinet.Fortigate.Traffic.LAN-DMZ.Allow",
    "partition_name_disp": "Firewall.Fortinet.Fortigate.Traffic.LAN-DMZ.Allow",
    "partition_type": "LAN-DMZ",
    "vendor_product": "Fortinet"
}]

    editorcontainer

  // enrichLimit=5
  // entityLimit=5

  nestedDropdown=[
    {
      "disp": "Port",
      "value": [
        {
          "disp": "Srcport",
          "value": "srcport",
          "type":"number",
          "state":1
        },
        {
          "disp": "Dstport",
          "value": "dstport",
          "type":"number",
          "state":1
        }
      ],
      "state":1
    },
    {
      "disp": "IP",
      "value": [
        {
          "disp": "Srcip",
          "value": "srcip",
          "type":"inet",
          "state":1
        },
        {
          "disp": "Dstip",
          "value": "dstip",
          "type":"inet",
          "state":1
        }
      ],
      "state":1
    }
  ]

  destroy$: Subject<boolean> = new Subject();

  showAlertFields=[]
  showEnrichFields=[]

  setFields(platform:any){
    this.actionFields=[]
    this.listFields=[]
    this.showAlertFields=[]
    this.platformFields=[]
// console.log("PlatformFields********",this.platformFields)
    this.platformfields=JSON.parse(JSON.stringify(this.sharedService.commonPlatformFields))

        Object.keys(this.platformfields).forEach(key => {
          // console.log("key",this.platformfields[key].is_entity)
          if(this.platformfields[key].is_entity){
            this.fields.push(this.platformfields[key])
           
            // console.log("Fields^^^^^^^^^^",this.fields)
          }
        });

    Object.keys(this.fields).forEach(key => {
      
      this.actionFields.push({'disp':this.fields[key].disp,'val':this.fields[key].value,'parent':platform})
      this.listFields.push({'disp':this.fields[key].disp,'value':this.fields[key].value,'type':this.fields[key].type})
      this.showAlertFields.push({'disp':this.fields[key].disp,'value':this.fields[key].value,'type':this.fields[key].type})
      this.actionmapping[this.fields[key].value]={'disp':this.fields[key].disp,'val':this.fields[key].value,'parent':platform}
      // console.log("NewActionFields>>>>>>>>",this.actionFields)

   
    })
    // console.log("Alert Fields -->",this.showAlertFields)
  
    // this.actions.alert_fields.fields_list.field[platform]=this.actionFields
  }

  setActionFields(platform:any){
    this.actionFields=[]
    this.listFields=[]
    this.showAlertFields=[]
//console.log("PlatformFields********",this.platformFields)
    // this.platformfields=this.sharedService.commonPlatformFields

    Object.keys(this.platformfields).forEach(key => {
      // console.log("key",this.platformfields[key].is_entity)
      // if(this.platformfields[key].is_entity){
        // this.fields.push(this.platformfields[key])
        // console.log("Fields^^^^^^^^^^",this.fields)
          // }
    });

        // this.listFields=[]
        // console.log(this.fields)

    Object.keys(this.fields).forEach(key => {
      // console.log(this.fields)
      this.actionFields.push({'disp':this.fields[key].image,'val':this.fields[key].image,'parent':platform})
      this.listFields.push({'disp':this.fields[key].image,'value':this.fields[key].image,'type':this.fields[key].type})
      this.showAlertFields.push({'disp':this.fields[key].image,'value':this.fields[key].image,'type':this.fields[key].type})
      this.actionmapping[this.fields[key].value]={'disp':this.fields[key].image,'val':this.fields[key].image,'parent':platform}
      // console.log("NewActionFields>>>>>>>>",this.actionFields)
      // console.log("Alert Fields -->",this.showAlertFields)
   
    })
    // console.log("Alert Action Fields -->",this.showAlertFields)
    // this.actions.alert_fields.fields_list.field[platform]=this.actionFields
    // this.createrulepreprocess()
    // this.getaction().addControl('tagsaction', this.structureTagsService.createTagControl(this.actions.alert_fields.fields_list.field));
//console.log("Distag",this.distag,"\n Fields",this.actions.alert_fields.fields_list.field)

//console.log(this.getaction())
}

defaultImpactedHosts={
  "toggleControl": false,
  "selectedTags": [],
  "selectedHosts": [
      "event",
      "traffic"
  ],
  "excludedHosts": {},
  "uniqueHostsLength": 2
}


calculate_timerange(time: any) {
  const currentusertime = this.timezoneservice.getcurrentuserTime();
  if (time[1] == "hour") {
    const start_date = currentusertime.clone().subtract(time[2], 'hour');
    return [start_date.format('YYYY-MM-DD HH:mm:ss'), currentusertime.format('YYYY-MM-DD HH:mm:ss')];
  } else if (time[1] == "today") {
    const start_date = currentusertime.clone();
    return [start_date.set({ 'hour': 0, 'minute': 0, 'second': 0 }).format('YYYY-MM-DD HH:mm:ss'), currentusertime.format('YYYY-MM-DD HH:mm:ss')];
  } else if (time[1] == "yesterday") {
    const start_date = currentusertime.clone().subtract(1, 'days');
    return [start_date.set({ 'hour': 0, 'minute': 0, 'second': 0 }).format('YYYY-MM-DD HH:mm:ss'), start_date.endOf('day').format('YYYY-MM-DD HH:mm:ss')];
  } else {
    const previousdate = currentusertime.clone().subtract(time[2], 'days');
    return [previousdate.set({ 'hour': 0, 'minute': 0, 'second': 0 }).format('YYYY-MM-DD HH:mm:ss'), currentusertime.format('YYYY-MM-DD HH:mm:ss')];
  }
}

inValidFields=[]

async verifyFields(){ // verify alertFields
  if(this.editState){
//console.log(this.querytokenprovider.parseTokens(this.ruleConditionEditor,'rule'))
    this.querytokenprovider.parseTokens(this.ruleConditionEditor,'rule')
    let request={"ruleId":this.editState ? this.editrequested.value.ruleId : '',"alert_fields":[]}
    this.querytokenprovider.parseTokens(this.ruleConditionEditor,'rule')['Statement'][0]["FetchCommand"].forEach(data=>{
      request.alert_fields.push(data.image)
    })
    this.ruleForm.get('actions').get('enrich').value.forEach(data=>{
      request.alert_fields.push(data.mappedFieldAlias)
    })
    if(await this.fieldsVerify(request)){
      this.errorState[1] = true;
      this.isInvalid=true
      return false
    }else{
      return true
    }
  }else{
    return true
  }
}


 async fieldsVerify(request){
  let inValid = false
  if(this.editState){
    await this.checkFields(request).toPromise().then((data:any)=>{
      // console.log(typeof(data))
      // console.log(data)
      if(data.length){
        inValid = true
        this.inValidFields=data
      }
//console.log(inValid)
      
    })
    return inValid
  }else{
    return inValid
  }
 
  
}

checkFields(request){
  // let response={
  //   "alert_fields":[
  //    "action","srcip"
  //   ]
  // }
  // return  of(response)
  return this.http.post(environment.apiUrl + '/rule/verify/get', request, { headers: this.headers })
}








chartPeriodData=[
  {
      "disp": "1 Hour",
      "value": [
          -1,
          "hour",
          1
      ]
  },
  {
      "disp": "3 Hours",
      "value": [
          -1,
          "hour",
          3
      ]
  },
  {
      "disp": "1 Day",
      "value": [
          -1,
          "day",
          0
      ]
  },
  {
      "disp": "2 Days",
      "value": [
          -1,
          "day",
          1
      ]
  },
//   {
//     "disp": "30 Days",
//     "value": [
//         -1,
//         "day",
//         29
//     ]
// }
]

chartData={}

chartOptions={
  "color": [
      "#0081b8",
      "#737373",
      "#454545",
      "#9e57bc",
      "#e0eff6",
      "#a6d4e7"
  ],
  "tooltip": {
      "trigger": "item"
  },
  "xAxis": {
      "type": "category",
      "axisLine": {
          "lineStyle": {
              "opacity": 0.2
          }
      },
      "data": [],
      "axisLabel":{}
  },
  "yAxis": {
      "type": "value",
      "axisLabel":{}
  },
  "grid": {
      "left": "2%",
      "right": "2%",
      "bottom": "5%",
      "top": "10%",
      "containLabel": true
  },
  "series": [
      {
          "data": [],
          "type": "line",
          "symbol": "diamond",
          "symbolSize": 5
      }
  ]
}

numberFormatter(value:number){
  if (value >= 1000000000000) {
    return (value / 1000000000000).toFixed(1) + 'T'; // Trillion
  } else if (value >= 1000000000) {
    return (value / 1000000000).toFixed(1) + 'B'; // Billion
  } else if (value >= 1000000) {
    return (value / 1000000).toFixed(1) + 'M'; // Million
  } else if (value >= 1000) {
    return (value / 1000).toFixed(1) + 'K'; // Thousand
  } else {
    return value; // If it's less than 1000, return the value as is
  }
}
dateFormatter(value: number): string {
  const timestamp = value.toString().length === 10 ? value * 1000 : value;
  return formatDate(timestamp, 'dd MMM HH:mm', 'en-US');
}
  
metaData=this.ruleMeta.ruledefault.metaData
defaultValues=this.ruleMeta.ruledefault.defaultValues

newtermLimit=JSON.parse(JSON.stringify(this.metaData.newtermLimit))
enrichLimit=JSON.parse(JSON.stringify(this.metaData.enrichLimit))
entityLimit=JSON.parse(JSON.stringify(this.metaData.entityLimit))

// moduleName="rule"
moduleName=this.ruleMeta.ruledefault.moduleName

// threat_intel_meta={
//   "labels":{
//     "provider_alias":"Provider alias (TI)",
//     "q1":"Q1 .",
//     "t1":"T1 ."
//   },
//   "errors":{
//     "type_error":"*Type Error"
//   },
//   "conditions_limit":10
// }
threat_intel_meta=JSON.parse(JSON.stringify(this.metaData.threat_intel_meta))

aggregation_meta=JSON.parse(JSON.stringify(this.metaData.aggregation_meta))
// aggregation_meta={
//   "labels":{
//     "aggregation_condition":"Aggregation Condition",
//     "fields":"Fields :",
//     "enable_sliding":"Enable Sliding",
//     "dynamic_threshold":"Dynamic Threshold",
//     "threshold":"Threshold",
//     "alert_when":"Alert When",
//     "and":"AND",
//     "threshold_based":"Threshold Based (time frame & threshold applied)"
//   },
//   "conditions_limit":5
// }

postQueryField=[]
postIntelField=[]

dataType=[
  {
    'disp':'Text',
    'value':'text'
  },
  {
    'disp':'Number',
    'value':'number'
  },
  {
    'disp':'inet',
    'value':'inet'
  }
]

intel_tableHeaders=['LIST NAME','PLATFORM','TYPE','CREATED TIME','TTL','LEARNING PERIOD','TOTAL ROWS']
intelList=[]
intelListGet=[]
// intelListGet=[
//   {
//     "list_id": "12",
//     "list_name": "Centiyent",
//     "platform": "Firewall Fortigate",
//     "ttl": 13,
//     "ttl_unit":86400,
//     "learning_period": 1,
//     "learning_unit":86400,
//     "max_entry":505,
//     "total_rows": 500,
//     "referenced": true,
//     "created_time": 1764051133
//   },
//   {
//     "list_id": "14",
//     "list_name": "CleartextPorts",
//     "platform": "Firewall Fortigate",
//     "ttl": 2,
//     "ttl_unit":86400,
//     "learning_period": 1,
//     "learning_unit":86400,
//     "max_entry":10000,
//     "total_rows": 10000,
//     "referenced": true,
//     "created_time": 1764051167
//   },
//   {
//     "list_id": "17",
//     "list_name": "hostile",
//     "platform": "Firewall Fortigate",
//     "ttl": 3,
//     "ttl_unit":86400,
//     "learning_period": 1,
//     "learning_unit":86400,
//     "max_entry":10000,
//     "total_rows": 10000,
//     "referenced": true,
//     "created_time": 1764051389
//   }
// ]

timeUnit=[
      {
          "disp": "Mins",
          "value": 60
      },
      {
          "disp": "Hours",
          "value": 3600
      },
      {
        "disp":"Days",
        "value":86400
      }
  ];

intelHead=["FIELD*","DATATYPE*","DESCRIPTION","PROPERTIES",""]

intelSelectedIndex:number=0

isIntel:boolean=false

propList=['enrichable','alias','isNull']

propListDisp={
  "enrichable":"IsEnrichable",
  "alias":"Alias",
  "isNull":"IsNull"
}

entryModes=['manual','import']

maxEntry=['10000','20000','50000']

// intelColumnLimit=4
intelColumnLimit=JSON.parse(JSON.stringify(this.metaData.intel_list_meta.colomnLimit))

// intelImportFileSize=5
intelImportFileSize=JSON.parse(JSON.stringify(this.metaData.intel_list_meta.fileSizeLimit))



importSizeLimit=this.intelImportFileSize*1024*1024

defaultIntel={
  "context":
  {
    "listName":"",
    "platform":"all",
    "ttlValue":"30",
    "timeUnit":86400,
    "maxEntry":"10000",
    "learningPeriodValue":"1",
    "learningUnit":86400,
    "unique":"true"
    
  },
  "createTable":{
    "table":[
      {
        "fieldName":"",
        "dataType": "text",
        "description": "",
        "enrichable": false,
        "alias": "",
        "isNull": false,
      }
    ]
  }
}

intelEditValue:any
// intelEditValue={
//   "context": {
//       "listName": "manual",
//       "platform": "all",
//       "ttlValue": 10,
//       "timeUnit": 86400,
//       "maxEntry": "20000",
//       "learningPeriodValue": 5,
//       "learningUnit": 86400,
//       "unique": "true"
//   },
//   "details":{
//     "rows":20000,
//     "referenced":false
//   },
//   "createTable": {
//       "table": [
//           {
//               "fieldName": "nextstat",
//               "dataType": "text",
//               "description": "",
//               "enrichable": false,
//               "alias": "",
//               "isNull": false
//           },
//           {
//               "fieldName": "proto",
//               "dataType": "text",
//               "description": "",
//               "enrichable": false,
//               "alias": "",
//               "isNull": false
//           },
//           {
//               "fieldName": "level",
//               "dataType": "text",
//               "description": "",
//               "enrichable": false,
//               "alias": "",
//               "isNull": false
//           },
//           {
//               "fieldName": "reason",
//               "dataType": "text",
//               "description": "",
//               "enrichable": false,
//               "alias": "",
//               "isNull": false
//           }
//       ]
//   }
// }

allFields=[]
importedFields=[]

importColumType={}

postFile=[]
postFileCols=[]

importDetail

learningTtlErr={"learning":false,"ttl":false}
learningTtlerrstr={"learning":"Learing period can't be bigger than TTL","ttl":"TTl can't be smaller than learning period"}
contextErrors={"listName":"*ListName can't be empty","TTL":"*Time to Live can't be 0 or empty","learning":"*Learning period can't be 0 or empty"}
contextShowError={"listName":false,"TTL":false,"learning":false}
createShowError=false
createErrors={"101":"*Field names can't be empty","102":"*Field names must be at least 4 characters long","103":"*Field names must be unique","104":"*Alias name is mandatory","105":"Spaces and special characters are not allowed"}
dataTypeError=[]
dataTypeErrorString='*Data type mismatch'
importIntelError:boolean=false
importErrorString ={"101":"*Imported fields must be unique","102":"*Imported fields can't be empty"}
manualIntelError:boolean=false
manualErrorString="*Fields can't be empty"
intelEditMode:boolean=false
// intelListOptions=[{"disp":"Import","value":"import"},{"disp":"Browse","value":"browse"},{"disp":"Download","value":"download"},{"disp":"Delete","value":"delete"}]
description_limit:number=25
intelListOptions=[
  {
    "disp": "Import Manually",
    "value": "import_manually"
  },
  {
    "disp": "Import CSV/XLSX",
    "value": "import_file"
  },
  {
    "disp": "View/Update",
    "value": "browse"
  },
  {
    "disp": "Download",
    "value": "download"
  },
  {
    "disp": "Delete",
    "value": "delete"
  }
]

intelViewOptions=[
  {
    "disp":"Edit",
    "value":"edit"
  },
  {
    "disp":"Delete",
    "value":"delete"
  }
]

viewIntel:any

viewIntelDeleteList=[]
viewIntelEditList=[]

intel_view_copy:any
intel_view_filtered:any

intel_view:any
// intel_view={
//   "referenced": false,
//   "fields": [
//     {
//       "fieldName": "action",
//       "dataType": "text",
//       "description": "",
//       "enrichable": true,
//       "alias": "action",
//       "isNull": true,
//       "column_alias": "$test_list_26012026.action"
//     },
//     {
//       "fieldName": "ipaddr",
//       "dataType": "text",
//       "description": "",
//       "enrichable": false,
//       "alias": "ipaddr",
//       "isNull": true,
//       "column_alias": "$test_list_26012026.ipaddr"
//     }
//   ],
//   "field_values": [
//     {
//       "action": "a",
//       "ipaddr": "1"
//     },
//     {
//       "action": "b",
//       "ipaddr": "2"
//     },
//     {
//       "action": "c",
//       "ipaddr": "3"
//     },
//     {
//       "action": "d",
//       "ipaddr": "4"
//     },
//     {
//       "action": "e",
//       "ipaddr": "5"
//     }
//   ]
// }


resetContextErrors(){
  Object.keys(this.contextShowError).forEach(key=>{
//console.log(this.contextShowError[key])
    this.contextShowError[key]=false
  })
  Object.keys(this.learningTtlErr).forEach(val => {
    this.learningTtlErr[val]=false
  })
}

contextValid:boolean=true

ruleLandingchangeTab(event: number) {
 this.ruleselectedIndex=event
}

intelForm = new FormGroup({
  context: new FormGroup({
    listName: new FormControl('',{
      validators:[Validators.required,Validators.maxLength(200),VerifyIntelListName()],
      asyncValidators: [IntelnameValidator.createValidator(this.ruleservice, this)]
    }),
    platform: new FormControl('',[Validators.required]),
    ttlValue: new FormControl('',[Validators.required]),
    timeUnit: new FormControl('',[Validators.required]),
    maxEntry: new FormControl('',[Validators.required]),
    learningPeriodValue: new FormControl('',[Validators.required]),
    learningUnit: new FormControl('',[Validators.required]),
    unique: new FormControl(),
    
  }),
  createTable:new FormGroup({
    table: new FormArray([
      this.addNewTable()
    ]),
    entryMode: new FormControl('manual'),
    remove: new FormControl()
  }),
 
})
importTable=[]
// importTable=[
//   {
//       "fieldName": "proto",
//       "dataType": "text",
//       "description": "",
//       "enrichable": false,
//       "alias": "",
//       "isNull": false,
//       "mappedField": ""
//   },
//   {
//       "fieldName": "action",
//       "dataType": "text",
//       "description": "",
//       "enrichable": false,
//       "alias": "",
//       "isNull": false,
//       "mappedField": ""
//   },
//   {
//       "fieldName": "service",
//       "dataType": "text",
//       "description": "",
//       "enrichable": false,
//       "alias": "",
//       "isNull": false,
//       "mappedField": ""
//   }
// ]

manualIntel = new FormGroup({
  manualTable : new FormArray([
     
  ])
})

addManual(){
  const group = new FormGroup({})
  Object.keys(this.intelForm.get('createTable').get('table').value).forEach(field=>{
    if(!this.intelForm.get('createTable').get('table').value[field].enrichable){
      group.addControl(this.intelForm.get('createTable').get('table').value[field].fieldName,new FormControl('',[Validators.required]))
    }
  })
//console.log({group})
  return group
}

addNewManual(){
  // console.log(this.importTable)
  const group = new FormGroup({})
  Object.keys(this.importTable).forEach(field=>{
    if(!this.importTable[field].enrichable){
      group.addControl(this.importTable[field].fieldName,new FormControl('',[Validators.required]))
    }
  })
//console.log({group})
  return group
}
setAliasValidators(){
  Object.keys(this.intelForm.get('createTable').get('table').value).forEach(key=>{
//console.log(this.intelForm.get('createTable').get('table').get(key.toString()).get('alias'))
    this.intelForm.get('createTable').get('table').get(key.toString()).get('alias').setValidators([Validators.required,Validators.maxLength(20),VerifyIntelListName()])
  })
}

addNewTable(){
  const group = new FormGroup({
    fieldName: new FormControl('',[Validators.required,Validators.minLength(4),VerifyIntelListName()]),
    dataType: new FormControl('text',[Validators.required]),
    description: new FormControl('',Validators.maxLength[25]),
    enrichable: new FormControl(false),
    alias: new FormControl('',[Validators.required,Validators.maxLength(200),VerifyIntelListName()]),
    isNull: new FormControl(false),
    mappedField: new FormControl(''),
    // uniqueId : new FormControl(this.randomString())
  })

  group.get('fieldName')!.valueChanges.subscribe((selectedField)=>{
    this.fieldName_Changes(group,selectedField)
  })

  group.get('mappedField')!.valueChanges.subscribe((selectedField: string) => {
    this.mappedField_valueChanges(group, selectedField);
  });

  return group
}

randomString(length = 16) { // create a uniqueId for intelList Import
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const array = new Uint8Array(length);
  crypto.getRandomValues(array);
  return Array.from(array).map(v => chars[v % chars.length]).join('');
}

fieldName_Changes(group,selectedField){
  // console.log({selectedField},Date.now())
  // group.get('uniqueId').setValue(Date.now())
  // console.log(group)
  
  // this.addManual()
  // if(!this.intelEditMode){
    if(selectedField){ // set alias as same as the field name
      if(group.get('alias').value){
        if(group.get('alias').pristine || !group.get('alias').touched){
          // console.log(group.get('alias'))
          group.get('alias').setValue(selectedField)
        }
      }else{
        group.get('alias').setValue(selectedField)
      }
    }else{
      if(group.get('alias').pristine){
        group.get('alias').setValue('')
      }
    }
  // }
}

jsonEdit(json: any): any {
  if (Array.isArray(json)) {
    // If it's an array → recursively process each element
    return json.map(v => this.jsonEdit(v));
  } else if (json && typeof json === 'object') {
    // If it's an object → recursively process each key
    const wrapped: any = {};
    Object.keys(json).forEach(key => {
      wrapped[key] = this.jsonEdit(json[key]);
    });
//console.log({wrapped})
    return wrapped;
  } else if (json === null || json === undefined) {
    // Convert null or undefined → empty string
    return "";
  } else {
    // Convert all other values → string
    
    return String(json);
  }
}
mappedField_valueChanges(group, selectedField){
  
  let selectedType
  if(selectedField?.length){
//console.log(group.get('dataType').value)
//console.log({selectedField})
    Object.keys(this.importColumType).forEach(key=>{
      if(key === selectedField)
      selectedType=this.importColumType[key]
    })
  
//console.log({selectedType})


    if(group.get('dataType').value === selectedType){

  
      // let index = this.importedFields.findIndex(key=>(key===selectedField))

      // this.importedFields.splice(index,1)
      // if(group.get('mappedField').value){
      //   if(group.get('mappedField').value != selectedField){
      //     this.importedFields.push(group.get('mappedField').value)
      //   }
      // }
      // this.importedFields=[]
      // this.importedFields=JSON.parse(JSON.stringify(this.allFields))
      // Object.keys(this.intelForm.get('createTable').get('table').value).forEach(key=>{
      //   if(this.intelForm.get('createTable').get('table').get(key.toString()).get('mappedField').value){
      //     this.importedFields.push(this.intelForm.get('createTable').get('table').get(key.toString()).get('mappedField').value)
      //   }

      // })
      // this.importedFields = this.importedFields.filter((item, _, array) => array.indexOf(item) === array.lastIndexOf(item));

      // console.log("array->",this.importedFields)
      Object.keys(this.dataTypeError).forEach(key=>{
        if(this.dataTypeError[key] === group.get('fieldName').value){
          let index = this.dataTypeError.findIndex(item => item === group.get('fieldName').value);
          this.dataTypeError.splice(index,1)
        }
      })
      
//console.log(this.dataTypeError)
    }
    else{
      this.dataTypeError.push(group.get('fieldName').value)
      this.dataTypeError = Array.from(new Map(this.dataTypeError.map(obj => [obj, obj])).values());

//console.log(this.dataTypeError)
//console.log("<------ DataType Error ------>")
    }
  }


}

nonEntity=[]
nonEntityError:boolean=false
nonEntityErrStr={"is":"is not in fetch ","are":"are not in fetch"}

checkForEntityFields(group,fetch){
//console.group("Tokens Check")
//console.log({group})
//console.log({fetch})
  let unique=[]
  this.nonEntity=[]
 
//console.groupEnd()
  const setA = new Set(group.map(x => x.image));
  const setB = new Set(fetch.map(x => x.image));
  unique=group.filter(x => !setB.has(x.image))
  this.nonEntity=unique

//console.log({unique})
 

}

buildAdvancedTokens(){
  let ImportCommand =this.querytokenprovider.parseTokens(this.ruleConditionEditor,'rule')['ImportCommand']
  let SearchCommand = this.querytokenprovider.parseTokens(this.ruleConditionEditor,'rule')['Statement'][0]['SearchCommand']
  let FromCommand = this.querytokenprovider.parseTokens(this.ruleConditionEditor,'rule')['Statement'][0]['FromCommand']
//console.log(SearchCommand)

  let CalculateCommand=[]
  Object.keys(this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").value).forEach(key=>{
    let subcat:string
    let alias:string
    let image:string
    let type:string="number"
    let params=[]
    if(this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").value[key]?.aggregate_function === "count_distinct"){
      alias="count_"+this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_field").value
      image="count"
      // type="number"
      if(this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_field").value){
        params.push("\""+this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_field").value+"\"")
      }      
    }else{
      alias=this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_function").value+"_"+this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_field").value
      image=this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_function").value
      // type="number"
      // params.push("\""+this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_field").value+"\"")
      if(this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").value[key]?.aggregate_function === "count"){
        if(this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_field").value){
          params.push("\""+this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_field").value+"\"")
        }
      }else{
        params.push("\""+this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_field").value+"\"")
      }
    }
    
    
    
    if(this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").value[key].aggregate_function === "count" || this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").value[key].aggregate_function === "count_distinct"){
      subcat="AggFunctionType1"
    }
    else{
      subcat="AggFunctionType2"
    }

    CalculateCommand.push({"cat":"function","subcat":subcat,"field":"","type":type,"alias":alias,"image":image,"params":params})
  })
//console.log({CalculateCommand})

  let ByCommand=[]
// console.log(this.totalPlatformFields)
// console.log(this.fieldsList)
  Object.keys(this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("group_fields").value).forEach(key=>{
    let keyIndex=this.fieldsList.findIndex(dat=>dat.value==this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("group_fields").value[key])
    // console.log({keyIndex})
    ByCommand.push({
      "image":this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("group_fields").value[key],
      "cat":"field",
      "type":this.fieldsList[keyIndex].display_type,
      "alias":this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("group_fields").value[key]
    })
  })
//console.log({ByCommand})

  let WhereCommand=[]

  Object.keys(this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").value).forEach(key=>{
    let image:string
    let alias:string
    let type:string
    if(this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").value[key].aggregate_function === "count_distinct"){
      image="count_"+this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_field").value
      alias="count_"+this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_field").value
    }
    else{
      image=this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_function").value+"_"+this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_field").value
      alias=this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_function").value+"_"+this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_field").value
    }
    if(this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").value[key].aggregate_function === "count_distinct" || this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").value[key].aggregate_function === "count"){
      type="text"
    }
    else{
      type="number"
    }
    if(parseInt(key)>0){
      WhereCommand.push({
        "image":"and",
        "cat":"termoperator",
        "type":""
      })
    }
    
    if(this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("operator").value == "between"){
      {
        WhereCommand.push({
          "alias":alias,
          "image":image,
          "cat":"tablecolumn",
          "type":type
        },
        {
          "alias":">",
          "image":">",
          "cat":"operator",
          "type":""
        },
        {
          "alias":this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("number_field_1").value.toString(),
          "image":this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("number_field_1").value.toString(),
          "cat":"value",
          "type":"number"
        },
        {
          "alias":"and",
          "image":"and",
          "cat":"termoperator",
          "type":""
        },
        {
          "alias":this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_function").value+"_"+this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_field").value,
          "image":this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_function").value+"_"+this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_field").value,
          "cat":"tablecolumn",
          "type":""
        },
        {
          "alias":"<",
          "image":"<",
          "cat":"operator",
          "type":""
        },
        {
          "alias":this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("number_field_2").value.toString(),
          "image":this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("number_field_2").value.toString(),
          "cat":"value",
          "type":"number"
        }
        )
      }
    }else{
      WhereCommand.push({
        "alias":alias,
        "image":image,
        "cat":"tablecolumn",
        "type":type
      },
      {
        "alias":this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("operator").value,
        "image":this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("operator").value,
        "cat":"operator",
        "type":""
      },
      {
        "alias":this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("number_field_1").value.toString(),
        "image":this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("number_field_1").value.toString(),
        "cat":"value",
        "type":"number"
      })
    }
  })

//console.log({WhereCommand})

  let FetchCommand=[]
  
  Object.keys(this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("group_fields").value).forEach(key=>{
    let keyIndex=this.fieldsList.findIndex(dat=>dat.value==this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("group_fields").value[key])
    FetchCommand.push({
      "image":this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("group_fields").value[key],
      "cat":"field",
      "type":this.fieldsList[keyIndex].display_type,
      "alias":this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("group_fields").value[key]
    })
  })
  Object.keys(this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").value).forEach(key=>{
    let type:string
    let alias:string
    let image:string
    if(this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").value[key].aggregate_function === "count_distinct" || this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").value[key].aggregate_function === "count"){
      type="text"
    }
    else{
      type="number"
    }
    if(this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").value[key].aggregate_function === "count_distinct"){
      alias="count_"+this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_field").value
      image="count_"+this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_field").value

    }else{
      alias=this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_function").value+"_"+this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_field").value
      image=this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_function").value+"_"+this.ruleForm.get('ruleConditions').get("triggers").get("aggregation").get("conditions").get(key.toString()).get("aggregate_field").value
    }
    FetchCommand.push({
      "cat":"tablecolumn",
      "type":type,
      "image":image,
      "alias":alias
    })
  })
  let Statement =[{"SearchCommand":SearchCommand,"FromCommand":FromCommand,"CalculateCommand":CalculateCommand,"ByCommand":ByCommand,"WhereCommand":WhereCommand,"FetchCommand":FetchCommand}]
  return {"ImportCommand":ImportCommand,"Statement":Statement}
  // return {"SearchCommand":SearchCommand,"CalculateCommand":CalculateCommand,"ByCommand":ByCommand,"WhereCommand":WhereCommand,"FetchCommand":FetchCommand}
}






//   metaData={"timeframe":[
//     {
//       "disp": "10 Minutes",
//       "value": 600,
//       "range":[{"min":600,"max":600}]
//     },
//     {
//       "disp": "20 Minutes",
//       "value": 1200,
//       "range":[{"min":600,"max":1200}]
//     },
//     {
//       "disp": "30 Minutes",
//       "value": 1800,
//       "range":[{"min":600,"max":1800}]
//     },
//     {
//       "disp": "1 Hour",
//       "value": 3600,
//       "range":[{"min":600,"max":3600}]
//     },
//     {
//       "disp": "2 Hours",
//       "value": 7200,
//       "range":[{"min":3600,"max":7200}]
//     },
//     {
//       "disp": "6 Hours",
//       "value": 21600,
//       "range":[{"min":3600,"max":21600}]
//     },
//     {
//       "disp": "12 Hours",
//       "value": 43200,
//       "range":[{"min":3600,"max":43200}]
//     },
//     {
//       "disp": "1 Day",
//       "value": 86400,
//       "range":[{"min":3600,"max":86400}]
//     },
//     {
//       "disp": "2 Days",
//       "value": 172800,
//       "range":[{"min":86400,"max":172800}]
//     },
//     {
//       "disp": "7 Days",
//       "value": 604800,
//       "range":[{"min":86400,"max":604800}]
//     },
//   ],
//   "stepsize":[
//     {
//       "disp": "10 Minutes",
//       "value": 600
//     },
//     {
//       "disp": "20 Minutes",
//       "value": 1200
//     },
//     {
//       "disp": "30 Minutes",
//       "value": 1800
//     },
//     {
//       "disp": "1 Hour",
//       "value": 3600
//     },
//     {
//       "disp": "2 Hours",
//       "value": 7200
//     },
//     {
//       "disp": "6 Hours",
//       "value": 21600
//     },
//     {
//       "disp": "12 Hours",
//       "value": 43200
//     },
//     {
//       "disp": "1 Day",
//       "value": 86400
//     },
//     {
//       "disp": "2 Days",
//       "value": 172800
//     },
//     {
//       "disp": "7 Days",
//       "value": 604800
//     },
//   ],
 
//   "placeHolder":["Timeframe","Stepsize"],
//   "standardRuleTriggers":[
//     {
//       "disp":"On First Event",
//       "value":"on_first_event"
//     },
//     {
//       "disp":"On Subsequnt Event",
//       "value":"on_subsequent_event"
//     },
//     {
//       "disp":"On Last Event",
//       "value":"on_last_event"
//     },
//     {
//       "disp":"On Every Event",
//       "value":"on_every_event"
//     }
//   ],
//   "RuleList":[
//     {
//       "disp":"Standard",
//       "value":"standard"
//     },
//     {
//       "disp":"Aggregation",
//       "value":"aggregation"
//     },
//     {
//       "disp":"New Term",
//       "value":"new_term"
//     },
//     {
//       "disp":"List",
//       "value":"list"
//     },
//     {
//       "disp":"Threat Intel",
//       "value":"threat_intel"
//     },
//     {
//       "disp":"Ratio",
//       "value":"ratio"
//     },
//     {
//       "disp":"Time Relative",
//       "value":"time_relative"
//     },
//     {
//       "disp":"Baseline",
//       "value":"baseline"
//     },
//     {
//       "disp":"Unique",
//       "value":"unique"
//     },
//     {
//       "disp":"AI Rule",
//       "value":"ai_rule"
//     }
//   ],
//   "timeTitles":[
//     {
//         "disp": "Mins",
//         "value": "mins"
//     },
//     {
//         "disp": "Hours",
//         "value": "hours"
//     }
//   ],
//   "displayTitles":{
//     "rule_cond_title":"Rule Query",
//     "query_1":"Query alias (Q1)",
//     "verify":"Verify query >",
//     "condition_title":"Generate an alert when the query meets the below criteria :",
//     "field_title":"New term in field : ",
//     "time_frame":"In time-frame",
//     "list_title":"Insert/Delete rule query results to List :",
//     "list_name":"List Name : ",
//     "insert":"INSERT",
//     "delete":"DELETE",
//     "actions":"Actions that need to be performed after an Alert has been triggered",
//     "set_alert_title":"Alert Entity Mapping",
//     "set_alert_subtitle":"Map appropriate fields from recognized Entities that are available in the Rule Query results. These field values will be available along each alert for further analysis.",
//     "alert_table_headers":["Entity Type","Column"],
//     "entityTypePlaceholder":"Choose Column",
//     "phantom":"Phantom Mode",
//     "phantom_on":"ON",
//     "phantom_off":"OFF",
//     "threat_intel":"Generate an alert when query field matches value in Threat Intel database",
//     "add_condition":"ADD CONDITION",
//     "null":"Allow Null",
//     "unique":"Unique Only",
//     "timeframe":"Time Frame",
//     "stepsize":"Stepsize"
//   },
//   "Errors":{
//     "101":"Invalid Condition",
//     "102":"StepSize is bigger than Timeframe",
//     "empty_conditions":"Conditions can't be empty",
//     "103":"*Actions invalid"
//   },
// }

// defaultValues={
//   "timeframeValue":{"standard":600,"threatIntel":86400,"aggregation":600,"list":600},
//   "stepsizeValue":{"standard":600,"threatIntel":86400,"aggregation":600,"list":600},
//   "ruleDefault":{
//     "context": {
//         "url": "",
//         "status": true,
//         "ruleName": "",
//         "severity": "low",
//         "providerId": "",
//         "falsePositive": "",
//         "knowledgebase": "",
//         "providersource": "Internal",
//         "ruleDescription": ""
//     },
//     "advanced": {
//         "alertType": ""
//     },
//     "ruleConditions": {
//       "queries":{
//         "query1":{
//           "query":"",
//           "timeframe":{
//             "disp": "1 Hour",
//             "value": 3600,
//             "range":[{"min":600,"max":3600}]
//           },
//           "stepsize":""
//         }
//       },
//         "platform": "firewall_fortigate",
//         "ruleType": "standard",
//         "impactedHost": {
//           "selectedTags": [],
//           "excludedHosts": {},
//           "selectedHosts": ["event","traffic"],
//           "toggleControl": false,
//           "uniqueHostsLength": 2
//       },
//     }
//   },
//   "defaultAction":{
//     "phantom_mode":false,
//     "alert_fields": {
//       "disp": "Set Alert Fields from Entities (*Mandatory)",
//       "enable": true,
//       "state": 0,
//       "fields_list": 
//         {
//           "entity_type": [
//             {
//               "disp": "Firewall Fortigate",
//               "value": "firewall_fortigate"
//             }
//           ],
//           "field":{
//             "firewall_fortigate": []
//           }
//         }
//     },
//     "notification": {
//       "disp": "Send Notifications",
//       "enable": false,
//       "state": 0,
//       "mailid": "",
//       "phone": null
//     },
//     "add_tags": {
//       "disp": "Add Tags",
//       "enable": true,
//       "state": 0,
//       "tags": [
//         {}
//       ]
//     },
//     "enrich": {
//       "disp": "Enrich",
//       "enable": false,
//       "state": 0,
//       "tags": [
//         {}
//       ]
//     },
//     "execute_cmd": {
//       "disp": "Execute Command",
//       "enable": false,
//       "state": 0,
//       "cmd": ""
//     },
//     "run_tasks": {
//       "disp": "Run Tasks",
//       "enable": false,
//       "state": 0,
//       "task": ""
//     }
//   },
//   "listRuleDefault":{
//     "listId":"",
//     "listName": "",
//     "unique": true,
//     "remove": false,
//     "list": {}
//   },
//   "defaultStepSize":[
//     {
//       "disp": "10 Minutes",
//       "value": 600
//     },
//     {
//       "disp": "20 Minutes",
//       "value": 1200
//     },
//     {
//       "disp": "30 Minutes",
//       "value": 1800
//     },
//     {
//       "disp": "1 Hour",
//       "value": 3600
//     }
//   ],

// }


  tableHeaders=[ // Not used
    "STATUS",
    "RULE ID",
    "RULE NAME",
    "PLATFORM",
    "RULE TYPE",
    "TAGS",
    "SEVERITY"
]

  tableTags={ // Not used
    "count":4,
    "value":{
      "compliance":['pcidss','iso27001'],
      "mitreattack":['reconnaissance','impact']
    }
  }
  tagList=[]

  getTagsList(){
    
    this.tagList=[]
      Object.keys(this.filteredruleList).forEach(key=>{
        // console.log("inside tag",this.filteredruleList[key].tags)
        if(this.filteredruleList[key].tags_count){
          Object.keys(this.filteredruleList[key].tags).forEach(tags=>{
            Object.keys(this.filteredruleList[key].tags[tags]).forEach(data=>{
              this.tagList.push(this.filteredruleList[key].tags[tags][data])
//console.log("TagList=====>>>>>>>",this.filteredruleList["taglist"])
              
            
            })
        
            
            // console.log("TagList=====>>>>>>>",this.filteredruleList["taglist"])
            
          })
          this.filteredruleList[key]["taglist"]=this.tagList
          this.tagList=[]
        }
      })

//console.log("filtered filter",this.filteredruleList)
    

  }


  list_used=[]

  getTokenList(tokens:any){
//console.log("Tokens",tokens)
    // console.log(this.list_used)
    this.list_used=[]
    if(tokens){
      Object.keys(tokens).forEach(key=>{
        if(tokens[key].cat==="list"){
          Object.keys(tokens[key].image).forEach(val=>{
            this.list_used.push(tokens[key].image[val])
          })
          // this.list_used.push(tokens[key].image)
  //console.log("List=",this.list_used)
        }
      })
    }
  }



  listNames=[]
  // public _ruleType = new Subject<string>();
  // $ruleType = this._ruleType.asObservable();
  public _ruleType = new BehaviorSubject<string | null>(null);
  public $ruleGroup = this._ruleType.asObservable();

  setRuleType(value: string) {
    this._ruleType.next(value);
  }

  public _closerule = new Subject<string | null>();
  public $closerule = this._closerule.asObservable();

  closerule(value: any) {
    this._closerule.next(value);
  }
  getListNames(): Observable<any[]> {
    return of(this.listNames);
  }

  getListFields(): Observable<any> {
    return of(this.list);
  }

  headers = new HttpHeaders({ 'content-type': 'application/json', 'charset': 'utf-8' });

getThreatList() {
  return this.http.post(environment.apiUrl + '/rule/threat_intel_list/get', JSON.stringify({}), { headers: this.headers });
}

getCommonPlatformFields(platform: any) {
    return this.http.post(environment.apiUrl + '/common/platformFields/get', JSON.stringify(platform), { headers: this.headers })
}
fetchPlatformFields(platform: string) {
  return this.getCommonPlatformFields({ 'platform': platform }).toPromise()
}

getIntelListName(platform: any) {
  return this.http.post(environment.apiUrl + '/rule/intel_listname/get', JSON.stringify(platform), { headers: this.headers })
}
fetchIntelListName() {
return this.getIntelListName({ 'platform': 'firewall_fortigate'}).toPromise()
}
getIntelListValues(listname: any) {
//console.log("Right befor Api call",listname)
  return this.http.post(environment.apiUrl + '/rule/intel_listfields/get', JSON.stringify(listname), { headers: this.headers })
}
fetchIntelListValues(listname:any) {
return this.getIntelListValues(listname).toPromise()
}



  //mock obj
  ruleConditionEditor: EditorView;

createruletab3="3.Actions"

  tabTitle:any =['Active Rules','Rules Repo','Intel List','LookBack'];
  titleActive=[ //Not Used
    "Total Rules",
    "Active Rules",
    "Inactive Rules",
    "Compliance Rules",
    "MITRE Att&ck Rules"
]
  titleRepo=[ // Not Used
    "Total Rules",
    "Active Rules",
    "Inactive Rules",
    "Compliance Rules",
    "MITRE Att&ck Rules"
]
  statsActive:any={ // Not Used
    "mitre": 1602,
    "total": 1716,
    "active": 1713,
    "inactive": 3,
    "compliance": 2
  };
  statsRepo:any={ // Not Used
    "mitre": 1,
    "total": 1,
    "active": 1,
    "inactive": 1,
    "compliance": 1
  };
  types=[ // Not Used
    {
      "disp":"Thread Detection Rule",
      "value":"thread_detection_rule"
    },
    {
      "disp":"Consolidation Rule",
      "value":"consolidation_rule"
    },
    {
      "disp":"Auto Closure Rule",
      "value":"auto_closure_rule"
    },
    {
      "disp":"Auto Investigate Rule",
      "value":"auto_investigate_rule"
    },
    {
      "disp":"Complex Rule",
      "value":"complex_rule"
    }
  ];
  timeframe=JSON.parse(JSON.stringify(this.metaData.timeframe))
  // timeframe=[
  //   {
  //     "disp": "10 Minutes",
  //     "value": 600,
  //     "range":[{"min":600,"max":600}]
  //   },
  //   {
  //     "disp": "20 Minutes",
  //     "value": 1200,
  //     "range":[{"min":600,"max":1200}]
  //   },
  //   {
  //     "disp": "30 Minutes",
  //     "value": 1800,
  //     "range":[{"min":600,"max":1800}]
  //   },
  //   {
  //     "disp": "1 Hour",
  //     "value": 3600,
  //     "range":[{"min":600,"max":3600}]
  //   },
  //   {
  //     "disp": "2 Hours",
  //     "value": 7200,
  //     "range":[{"min":3600,"max":7200}]
  //   },
  //   {
  //     "disp": "6 Hours",
  //     "value": 21600,
  //     "range":[{"min":3600,"max":21600}]
  //   },
  //   {
  //     "disp": "12 Hours",
  //     "value": 43200,
  //     "range":[{"min":3600,"max":43200}]
  //   },
  //   {
  //     "disp": "1 Day",
  //     "value": 86400,
  //     "range":[{"min":3600,"max":86400}]
  //   },
  //   {
  //     "disp": "2 Days",
  //     "value": 172800,
  //     "range":[{"min":86400,"max":172800}]
  //   },
  //   {
  //     "disp": "7 Days",
  //     "value": 604800,
  //     "range":[{"min":86400,"max":604800}]
  //   },
  //   {
  //     "disp": "30 Days",
  //     "value": 2592000,
  //     "range":[{"min":86400,"max":2592000}]
  //   },
  //   {
  //     "disp": "60 Days",
  //     "value": 5184000,
  //     "range":[{"min":86400,"max":5184000}]
  //   },
  //   {
  //     "disp": "90 Days",
  //     "value": 7776000,
  //     "range":[{"min":86400,"max":7776000}]
  //   }
  // ]

  stepsize1:[{"disp":string,"value":number}]=JSON.parse(JSON.stringify(this.metaData.stepsize))
  // stepsize1=[
  //   {
  //     "disp": "10 Minutes",
  //     "value": 600
  //   },
  //   {
  //     "disp": "20 Minutes",
  //     "value": 1200
  //   },
  //   {
  //     "disp": "30 Minutes",
  //     "value": 1800
  //   },
  //   {
  //     "disp": "1 Hour",
  //     "value": 3600
  //   },
  //   {
  //     "disp": "2 Hours",
  //     "value": 7200
  //   },
  //   {
  //     "disp": "6 Hours",
  //     "value": 21600
  //   },
  //   {
  //     "disp": "12 Hours",
  //     "value": 43200
  //   },
  //   {
  //     "disp": "1 Day",
  //     "value": 86400
  //   },
  //   {
  //     "disp": "2 Days",
  //     "value": 172800
  //   },
  //   {
  //     "disp": "7 Days",
  //     "value": 604800
  //   },
  //   {
  //     "disp": "30 Days",
  //     "value": 2592000
  //   },
  //   {
  //     "disp": "60 Days",
  //     "value": 5184000
  //   },
  //   {
  //     "disp": "90 Days",
  //     "value": 7776000
  //   }
  // ]

  stepsizeDefault=JSON.parse(JSON.stringify(this.defaultValues.defaultStepSize))
  // stepsizeDefault=[
  //     {
  //       "disp": "10 Minutes",
  //       "value": 600
  //     }
  //   ]

  stepsize=JSON.parse(JSON.stringify(this.defaultValues.defaultStepSize))
  // stepsize=[
  //   {
  //     "disp": "10 Minutes",
  //     "value": 600
  //   },
  //   {
  //     "disp": "20 Minutes",
  //     "value": 1200
  //   },
  //   {
  //     "disp": "30 Minutes",
  //     "value": 1800
  //   },
  //   {
  //     "disp": "1 Hour",
  //     "value": 3600
  //   }
  // ]
  placeholder=JSON.parse(JSON.stringify(this.metaData.placeHolder))
  // placeholder=["Timeframe","Stepsize"]
  standardCond=JSON.parse(JSON.stringify(this.metaData.standardRuleTriggers))

  agg_threshold=JSON.parse(JSON.stringify(this.metaData.standardRuleTriggers))
  // standardCond=[
  //   {
  //     "disp":"On First Event",
  //     "value":"on_first_event"
  //   },
  //   {
  //     "disp":"On Subsequnt Event",
  //     "value":"on_subsequent_event"
  //   },
  //   {
  //     "disp":"On Last Event",
  //     "value":"on_last_event"
  //   },
  //   {
  //     "disp":"On Every Event",
  //     "value":"on_every_event"
  //   }
  // ];

  dynamic_threshold=[
  {
    "disp":"Top 1 Threshold",
    "value":"top_1_threshold"
  },
  {
    "disp":"Top 5 Threshold",
    "value":"top_5_threshold"
  },
  {
    "disp":"Top 10 Threshold",
    "value":"top_10_threshold"
  },
  {
    "disp":"Bottom 1 Threshold",
    "value":"bottom_1_threshold"
  },
  {
    "disp":"Bottom 5 Threshold",
    "value":"bottom_5_threshold"
  },
  {
    "disp":"Bottom 10 Threshold",
    "value":"bottom_10_threshold"
  }
]




  threadRules=JSON.parse(JSON.stringify(this.metaData.RuleList))
  // threadRules=[
  //   {
  //     "disp":"Standard",
  //     "value":"standard",
  //     "status":1
  //   },
  //   {
  //     "disp":"Aggregation",
  //     "value":"aggregation",
  //     "status":1
  //   },
  //   {
  //     "disp":"New Term",
  //     "value":"new_term",
  //     "status":1
  //   },
  //   {
  //     "disp":"Threat Intel",
  //     "value":"threat_intel",
  //     "status":1
  //   },
  //   {
  //     "disp":"Ratio",
  //     "value":"ratio",
  //     "status":0
  //   },
  //   {
  //     "disp":"Time Relative",
  //     "value":"time_relative",
  //     "status":0
  //   },
  //   {
  //     "disp":"AI Rule",
  //     "value":"ai_rule",
  //     "status":0
  //   }
  // ];

  fields=[]

  // fields=[
  //   {
  //     "disp":"nextstat",
  //     "value":"nextstat"
  //   },
  //   {
  //     "disp":"outintf",
  //     "value":"outintf"
  //   },
  //   {
  //     "disp":"setuprate",
  //     "value":"setuprate"
  //   },
  //   {
  //     "disp":"stage",
  //     "value":"stage"
  //   }
  // ];
  time=JSON.parse(JSON.stringify(this.metaData.timeTitles))
  // time=[
  //     {
  //         "disp": "Mins",
  //         "value": "mins"
  //     },
  //     {
  //         "disp": "Hours",
  //         "value": "hours"
  //     },
  //     {
  //       "disp":"Days",
  //       "value":"days"
  //     }
  // ];
  alertFieldError={
    "required": "*Alert field is required",
    "alreadyExists": "Alert fields must be unique",
    "typeError": "Data type mismatched"

  }

  // enrichAlertFieldError={
  //   "required": "*Alert field is required",
  //   "alreadyExists": "Already exists",
  //   "typeError": "Data type mismatched",
  //   "exists":"Doesn't exists"
  // }
  enrichAlertFieldError={
    "required": "*Alert field is required",
    "alreadyExists": "Already exists",
    "typeError": "Data type mismatched",
    "exists":"Field doesn't exists",
    "$priority$":["required","exists","alreadyExists","typeError"]
  }

  mappedFieldError={
    "required": "*An enrichment field is required",
    "alreadyExists": "An enrichment field from this list already exists."
  }
  mappedAliasError={
    "required":"*Alias name is required",
    "nonUniqueValue":"Alias name already exists"
  }
  phoneError={
    "required":"*Phone number is mandatory",
    "numberError":"Invalid phone number"
  }
  emailError={
    "required":"*Email Id is mandatory",
    "emailError":"Invalid mail Id"
  }
  messageError={
    "required":"message can't be empty"
  }

  intelViewError={
    "required":"*Field can't be empty",
    "textError":"Value must be a text",
    "numberError":"Value must be a number",
    "ipError":"Value must be an IP"
  }

  // titles=JSON.parse(JSON.stringify(this.metaData.displayTitles))
  titles={
    "rule_cond_title": "Rule Query",
    "query_1": "Query alias (Q1)",
    "verify": "Verify query >",
    "condition_title": "Generate an alert when the query meets the below criteria :",
    "field_title": "New term in field : ",
    "time_frame": "In time-frame",
    "list_title": "Insert/Delete rule query results to List :",
    "list_name": "List Name : ",
    "insert": "INSERT",
    "delete": "DELETE",
    "actions": "Actions that need to be performed after an Alert has been triggered",
    "set_alert_title": "Alert Entity Mapping",
    "set_alert_subtitle": "Map appropriate fields from recognized Entities that are available in the Rule Query results. These field values will be available along each alert for further analysis.",
    "alert_table_headers": [
        "Entity Fields",
        "Alert Fields"
    ],
    "enrich_headers":[
      "List Fields",
      "",
      "Alert Fields",
      "Enrichment Fields",
      ""
    ],
    "entityTypePlaceholder": "Choose Column",
    "phantom": "Phantom Mode",
    "phantom_on": "ON",
    "phantom_off": "OFF",
    "threat_intel": "Generate an alert when query field matches value in Threat Intel database",
    "add_condition": "ADD CONDITION",
    "null": "Allow Null",
    "unique": "Unique Only",
    "timeframe": "Time Frame",
    "stepsize": "Stepsize",
    "rule_title":"Define the logic for ",
    "list_id_label":"Choose the list that will store this indicator:",
    "list_unique":"Unique",
    "null_allowed":"isNullAllowed : ",
    "enrichable":"isEnrichable : ",
    "data_type_error":"Datatype mismatched",
    "communications":"Select the method to send communications."
}

chartPaginationLimit=3
chartPagination=0
  

  list_cond={"list":[]}
    // {
    //   "disp":"Field 1",
    //   "value":"field_1",
    //   "null":true,
    //   "unique":false,
    //   "data_edit":true
    // },
    // {
    //   "disp":"Field 2",
    //   "value":"field_2",
    //   "null":false,
    //   "unique":false,
    //   "data_edit":false
    // },
    // {
    //   "disp":"Field 3",
    //   "value":"field_3",
    //   "null":true,
    //   "unique":true,
    //   "data_edit":true
    // }
  // ]
  // list_cond_disp={
  //   "null":"Allow Null",
  //   "unique":"Unique Only"
  // }

//   list={
//     "listId":"",
//     "listName": "",
//     "unique": false,
//     "remove": false,
//     "list": {
//         "c1": {
//             "disp": "Field 1",
//             "isNullAllowed": true,
//             "isEnrichable": true,
//             "field": "",
//             "type": "text"
//         },
//         "c2": {
//             "disp": "Field 2",
//             "isNullAllowed": false,
//             "isEnrichable": false,
//             "field": "",
//             "type": "inet"
//         },
//         // "c3": {
//         //     "disp": "Field 3",
//         //     "isNullAllowed": true,
//         //     "isEnrichable": true,
//         //     "field": "",
//         //     "type": "text"
//         // }
//     }
// }
errorType=JSON.parse(JSON.stringify(this.metaData.Errors))
  // errorType={"101":"Invalid Condition","102":"StepSize is bigger than Timeframe","empty_conditions":"Conditions can't be empty","103":"*Actions invalid","104":"*Please select at least one action to execute in Phantom mode.","105":"*Please select source","106":"Aggregation conditions are not allowed"}
  
  isInvalid:boolean=true

  conditionsValid:boolean=false

  // timetitle={"timeframe":"Time Frame","stepsize":"Stepsize"}

 

list=JSON.parse(JSON.stringify(this.defaultValues.listRuleDefault))
//   list={
//     "listId":"",
//     "listName": "",
//     "unique": true,
//     "remove": false,
//     "list": {
//         // "c1": {
//         //     "disp": "Field 1",
//         //     "isNullAllowed": true,
//         //     "isEnrichable": true,
//         //     "field": "",
//         //     "type": "text"
//         // },
//         // "c2": {
//         //     "disp": "Field 2",
//         //     "isNullAllowed": false,
//         //     "isEnrichable": false,
//         //     "field": "",
//         //     "type": "inet"
//         // }
//     }
// }

// actions=JSON.parse(JSON.stringify(this.defaultValues.defaultAction))
defaultAction={
  // "phantom_mode":false,
  
  "enrich": {
    "disp": "Enrich",
    "enable": true,
    "state": 0,
    "group":'enrich'
   
  },
  "alert_fields": {
    "disp": "Entity mapping",
    "enable": true,
    "state": 0,
    "group":'entity_map',
    "fields_list": 
      {
        // "entity_type": [
        //   {
        //     "disp": "Firewall Fortigate",
        //     "value": "firewall_fortigate"
        //   }
        // ],
        // "field":{
        //   "firewall_fortigate": [              
        //   ],
        // }
        
      }
    
  },
  "manage_list": {
    "disp": "Insert or delete list",
    "enable": true,
    "state": 0,
    "group":'manage_list',
    "list":{}
  },
  "notification": {
    "disp": "Send Communications",
    "enable": true,
    "state": 0,
    "mailid": "",
    "group":'communications',
    "phone": null
  }
  // "add_tags": {
  //   "disp": "Add Tags",
  //   "enable": true,
  //   "state": 0,
  //   "tags": [
  //     {}
  //   ]
  // },
 
  // "execute_cmd": {
  //   "disp": "Execute Command",
  //   "enable": false,
  //   "state": 0,
  //   "cmd": ""
  // },
  // "run_tasks": {
  //   "disp": "Run Tasks",
  //   "enable": false,
  //   "state": 0,
  //   "task": ""
  // }
}
// actions=JSON.parse(JSON.stringify(this.defaultAction))
  actions={
    // "phantom_mode":false,
    
    "enrich": {
      "disp": "Enrich",
      "enable": true,
      "state": 0,
      "group":'enrich',
      "tags": [
        {}
      ]
    },
    "alert_fields": {
      "disp": "Entity mapping",
      "enable": true,
      "state": 0,
      "group":'entity_map',
      "fields_list": 
        {
          "entity_type": [
            {
              "disp": "Firewall Fortigate",
              "value": "firewall_fortigate"
            }
          ],
          "field":{
            "firewall_fortigate": [              
            ],
          }
          
        }
      
    },
    "manage_list": {
      "disp": "Insert or delete list",
      "enable": true,
      "state": 0,
      "group":'manage_list',
      "list":{}
    },
    "notification": {
      "disp": "Send Communications",
      "enable": true,
      "state": 0,
      "group":'communications',
      "mailid": "",
      "phone": null
    }
    // "add_tags": {
    //   "disp": "Add Tags",
    //   "enable": true,
    //   "state": 0,
    //   "tags": [
    //     {}
    //   ]
    // },
   
    // "execute_cmd": {
    //   "disp": "Execute Command",
    //   "enable": false,
    //   "state": 0,
    //   "cmd": ""
    // },
    // "run_tasks": {
    //   "disp": "Run Tasks",
    //   "enable": false,
    //   "state": 0,
    //   "task": ""
    // }
  }


// actionList={
//   "listName": "cust_public",
//   "unique": true,
//   "remove":false,
//   "list": {
    
//       "c1": {
//         "disp": "ip",
//         "isNullAllowed": false,
//         "isEnrichable": false,
//         "field": "",
//         "type": "inet"
//       }
//     ,
    
//       "c2": {
//         "disp": "country",
//         "isNullAllowed": false,
//         "isEnrichable": false,
//         "field": "",
//         "type": "text"
//       }
//     }
    
  
// }
actionList={}
actionHeadList=['Field','Properties','Alert Field']
actionmapping={}
//   actionmapping={
//     "action":{
//         "disp": "action",
//         "val": "action",
//         "parent": "firewall_fortigate"
//     },
//     "service":{
//         "disp": "service",
//         "val": "service",
//         "parent": "firewall_fortigate"
//     },
//     "crlevel":{
//         "disp": "crlevel",
//         "val": "crlevel",
//         "parent": "firewall_fortigate"
//     },
//     "dstcountry":{
//         "disp": "dstcountry",
//         "val": "dstcountry",
//         "parent": "firewall_fortigate"
//     },
//     "dstintf":{
//         "disp": "dstintf",
//         "val": "dstintf",
//         "parent": "firewall_fortigate"
//     },
//     "dstport":{
//         "disp": "dstport",
//         "val": "dstport",
//         "parent": "firewall_fortigate"
//     },
//     "policyid":{
//         "disp": "policyid",
//         "val": "policyid",
//         "parent": "firewall_fortigate"
//     },
//     "source":{
//         "disp": "source",
//         "val": "source",
//         "parent": "firewall_fortigate"
//     },
//     "srccountry":{
//         "disp": "srccountry",
//         "val": "srccountry",
//         "parent": "firewall_fortigate"
//     },
//     "srcintf":{
//         "disp": "srcintf",
//         "val": "srcintf",
//         "parent": "firewall_fortigate"
//     },
//     "subtype":{
//         "disp": "subtype",
//         "val": "subtype",
//         "parent": "firewall_fortigate"
//     },
//     "transip":{
//         "disp": "transip",
//         "val": "transip",
//         "parent": "firewall_fortigate"
//     },
//     "srcport":{
//         "disp": "srcport",
//         "val": "srcport",
//         "parent": "firewall_fortigate"
//     },
//     "dstip":{
//         "disp": "dstip",
//         "val": "dstip",
//         "parent": "firewall_fortigate"
//     },
//     "srcip":{
//         "disp": "srcip",
//         "val": "srcip",
//         "parent": "firewall_fortigate"
//     }
// }
  
  // actionmapping={
  //   "srcip":{
  //     "disp": "SrcIp",
  //     "val": "srcip",
  //     "parent": "firewall_fortigate"
  //   },
  //   "nextstat": {
  //     "val": "nextstat",
  //     "disp": "nextstat",
  //     "parent": "firewall_fortigate"
  //   },
  // }
  //   "outintf": {
  //     "val": "outintf",
  //     "disp": "outintf",
  //     "parent": "firewall_fortigate"
  //   },
  //   "setuprate": {
  //     "val": "setuprate",
  //     "disp": "setuprate",
  //     "parent": "firewall_fortigate"
  //   },
  //   "stage": {
  //     "val": "stage",
  //     "disp": "stage",
  //     "parent": "firewall_fortigate"
  //   },
  //   "srcips":{
  //     "disp": "SrcIp",
  //     "val": "srcip",
  //     "parent": "firewall_fortigate"
  //   },
  //   "nextstats": {
  //     "val": "nextstat",
  //     "disp": "nextstat",
  //     "parent": "firewall_fortigate"
  //   },
  // }
  mockmeta=JSON.parse(JSON.stringify(this.defaultValues.ruleDefault))
//   mockmeta={
//     "context": {
//         "url": "",
//         "status": true,
//         // "platform": "firewall_fortigate",
//         "ruleName": "",
//         // "ruleType": "atomic",
//         "severity": "low",
//         "providerId": "",
//         // "impactedHost": {
//         //     "selectedTags": [],
//         //     "excludedHosts": {},
//         //     "selectedHosts": [
//         //         "event"
//         //     ],
//         //     "toggleControl": false,
//         //     "uniqueHostsLength": 1
//         // },
//         "falsePositive": "",
//         "knowledgebase": "",
//         "providersource": "Internal",
//         "ruleDescription": ""
//     },
//     "advanced": {
//         "alertType": ""
//     },
//     "ruleConditions": {
//       "queries":{
//         "query1":{
//           "query":"",
//           "timeframe":{
//             "disp": "1 Hour",
//             "value": 3600,
//             "range":[{"min":600,"max":3600}]
//           },
//           "stepsize":""
//         }
//       },
//         // "conditionQuery": "",
//         "platform": "firewall_fortigate",
//         "ruleType": "standard",
//         "impactedHost": {
//           "selectedTags": [],
//           "excludedHosts": {},
//           "selectedHosts": [
             
//           ],
//           "toggleControl": false,
//           "uniqueHostsLength": 0
//       },
//     }
// }

mockDefault={
  "actions": {
    "phantom": false,
    "alert_fields": {
        "enable": true,
        "state": false,
        "fields_list": [
            {
                "entity_type": "IP",
                "field": [
                    "Srcip",
                    "Dstip"
                ]
            }
        ]
    },
    "notification": {
        "enable": true,
        "state": false,
        "mailid": "",
        "phone": null
    },
    "execute_cmd": {
        "enable": false,
        "state": false,
        "cmd": ""
    },
    "run_tasks": {
        "enable": false,
        "state": false,
        "task": ""
    },
    "add_tags": {
        "enable": true,
        "state": false,
        "tags": {
            "killchain": [],
            "compliance": [
                "pcidss",
                "gprc",
                "iso27001"
            ],
            "mitreattack": [],
            "threatgroup": []
        }
    },
    "enrichment": {
        "enable": true,
        "state": false,
        "enrichable_fields": [
            {
                "Srcip": [
                    "ASN",
                    "Country",
                    "Host",
                    "Malware",
                    "Reputation",
                    "Whois"
                ]
            }
        ]
    }
},
  "context": {
      "url": "",
      "status": true,
      // "platform": "firewall_fortigate",
      "ruleName": "",
      // "ruleType": "atomic",
      "severity": "low",
      "providerId": "",
      "impactedHost": {
          "selectedTags": [],
          "excludedHosts": {},
          "selectedHosts": [
              "event"
          ],
          "toggleControl": false,
          "uniqueHostsLength": 1
      },
      "falsePositive": "",
      "knowledgebase": "",
      "providersource": "Internal",
      "ruleDescription": ""
  },
  "advanced": {
      "alertType": ""
  },
  "ruleConditions": {
    "ruleType": "standard",
    "platform": "firewall_fortigate",
    "queries":{
      "query1":{
        "query":"",
        "timeframe": 3600,
        "stepsize":{
          "disp": "1 Hour",
          "value": 3600
        },
      }
    }
  }
}

  //common
  
  commonData: any = this.sharedService.metaData.commonData;
  platformFields = [];
  platformMap = this.sharedService.platformMap;

  //rulecomponent
  ruleStat: any;
  ruleList = [];
  ruleActiveList=[]
  filteredruleList = [];
  lookbacklist:any[] = [];
  eventFieldOptions = [];

  ruleselectedIndex:number = 0;

  ruletablesearch = new FormControl('');
  rulerepotablesearch = new FormControl('')
  inteltablesearch = new FormControl('');
  intelviewsearch = new FormControl('');
  ruleitemperpage = new FormControl(this.ruleMeta.paginationDefault.itemPerPage);
  rulerepoitemperpage = new FormControl(this.ruleMeta.paginationDefault.itemPerPage);
  intelitemperpage = new FormControl(this.ruleMeta.paginationDefault.itemPerPage);
  intelViewitemperpage = new FormControl(this.ruleMeta.paginationDefault.itemPerPage);
  rulepagenumber = 1;
  rulerepopagenumber=1; // for rules repo 
  intelpagenumber=1; // for Intel list
  intelViewpagenumber=1 // intel view
  rulepagelength = 1;
  rulerepopagelength =1 // for rules repo
  intelpagelength =1 // for intel list
  intelViewpagelength=1 // intel view
  lookbackitemperpage = new FormControl(this.ruleMeta.paginationDefault.itemPerPage);
  lookbackpagenumber = 1;
  lookbackpagelength = 1;

  //ruleform
  errorState = new Array(3).fill(false);
  selectedIndex:number = 0;
  editSend = {}
  
  editdatatocheckchanges:any = {};
  tagmapping = {};
  distag = {};
  tagsSet = new Set();
  editrequested = {
    state:false,
    value:null
  };
  // threatIntelList=[
  //   {
  //     "disp":"Centiyent Threat Intel",
  //     "value":"centiyent_threat_intel",
  //     "fields":[
  //       {
  //           "disp": "action",
  //           "type": "text",
  //           "value": "action",
  //           "is_view": true,
  //           "is_entity": 1,
  //           "display_type": "text",
  //           "isDisp_table": true,
  //           "isDisp_filter": true
  //       },
  //       {
  //           "disp": "service",
  //           "type": "text",
  //           "value": "service",
  //           "is_view": true,
  //           "is_entity": 1,
  //           "display_type": "text",
  //           "isDisp_table": true,
  //           "isDisp_filter": true
  //       },
  //       {
  //           "disp": "dstip",
  //           "type": "text",
  //           "value": "dstip",
  //           "is_view": true,
  //           "is_entity": 1,
  //           "display_type": "inet",
  //           "isDisp_table": true,
  //           "isDisp_filter": true
  //       },
  //       {
  //           "disp": "srcip",
  //           "type": "text",
  //           "value": "srcip",
  //           "is_view": true,
  //           "is_entity": 1,
  //           "display_type": "inet",
  //           "isDisp_table": true,
  //           "isDisp_filter": true
  //       },
  //       {
  //           "disp": "crlevel",
  //           "type": "text",
  //           "value": "crlevel",
  //           "is_view": true,
  //           "is_entity": 1,
  //           "display_type": "text",
  //           "isDisp_table": true,
  //           "isDisp_filter": true
  //       },
  //       {
  //           "disp": "dstcountry",
  //           "type": "text",
  //           "value": "dstcountry",
  //           "is_view": true,
  //           "is_entity": 1,
  //           "display_type": "text",
  //           "isDisp_table": true,
  //           "isDisp_filter": true
  //       },
  //       {
  //           "disp": "dstintf",
  //           "type": "text",
  //           "value": "dstintf",
  //           "is_view": true,
  //           "is_entity": 1,
  //           "display_type": "text",
  //           "isDisp_table": true,
  //           "isDisp_filter": true
  //       },
  //       {
  //           "disp": "policyid",
  //           "type": "text",
  //           "value": "policyid",
  //           "is_view": true,
  //           "is_entity": 1,
  //           "display_type": "text",
  //           "isDisp_table": true,
  //           "isDisp_filter": true
  //       },
  //       {
  //           "disp": "source",
  //           "type": "text",
  //           "value": "source",
  //           "is_view": true,
  //           "is_entity": 1,
  //           "display_type": "text",
  //           "isDisp_table": true,
  //           "isDisp_filter": true
  //       },
  //       {
  //           "disp": "srccountry",
  //           "type": "text",
  //           "value": "srccountry",
  //           "is_view": true,
  //           "is_entity": 1,
  //           "display_type": "text",
  //           "isDisp_table": true,
  //           "isDisp_filter": true
  //       },
  //       {
  //           "disp": "srcintf",
  //           "type": "text",
  //           "value": "srcintf",
  //           "is_view": true,
  //           "is_entity": 1,
  //           "display_type": "text",
  //           "isDisp_table": true,
  //           "isDisp_filter": true
  //       },
  //       {
  //           "disp": "subtype",
  //           "type": "text",
  //           "value": "subtype",
  //           "is_view": true,
  //           "is_entity": 1,
  //           "display_type": "text",
  //           "isDisp_table": true,
  //           "isDisp_filter": true
  //       },
  //       {
  //           "disp": "transip",
  //           "type": "text",
  //           "value": "transip",
  //           "is_view": true,
  //           "is_entity": 1,
  //           "display_type": "text",
  //           "isDisp_table": true,
  //           "isDisp_filter": true
  //       },
  //       {
  //           "disp": "dstport",
  //           "type": "text",
  //           "value": "dstport",
  //           "is_view": true,
  //           "is_entity": 1,
  //           "display_type": "number",
  //           "isDisp_table": true,
  //           "isDisp_filter": true
  //       },
  //       {
  //           "disp": "srcport",
  //           "type": "text",
  //           "value": "srcport",
  //           "is_view": true,
  //           "is_entity": 1,
  //           "display_type": "number",
  //           "isDisp_table": true,
  //           "isDisp_filter": true
  //       }
  //   ]
  //   },
  //   {
  //     "disp":"Cisco Threat Intel",
  //     "value":"cisco_threat_intel",
  //     "fields":[
  //       {
  //           "disp": "action",
  //           "type": "text",
  //           "value": "action",
  //           "is_view": true,
  //           "is_entity": 1,
  //           "display_type": "text",
  //           "isDisp_table": true,
  //           "isDisp_filter": true
  //       },
  //       {
  //           "disp": "service",
  //           "type": "text",
  //           "value": "service",
  //           "is_view": true,
  //           "is_entity": 1,
  //           "display_type": "text",
  //           "isDisp_table": true,
  //           "isDisp_filter": true
  //       },
  //       {
  //           "disp": "dstip",
  //           "type": "text",
  //           "value": "dstip",
  //           "is_view": true,
  //           "is_entity": 1,
  //           "display_type": "inet",
  //           "isDisp_table": true,
  //           "isDisp_filter": true
  //       },
  //       {
  //           "disp": "srcip",
  //           "type": "text",
  //           "value": "srcip",
  //           "is_view": true,
  //           "is_entity": 1,
  //           "display_type": "inet",
  //           "isDisp_table": true,
  //           "isDisp_filter": true
  //       },
  //       {
  //           "disp": "crlevel",
  //           "type": "text",
  //           "value": "crlevel",
  //           "is_view": true,
  //           "is_entity": 1,
  //           "display_type": "text",
  //           "isDisp_table": true,
  //           "isDisp_filter": true
  //       }]
  //   },
  // ]
  threatIntelList:any
  // threatFieldList={
  //   "centiyent_threat_intel":["A1","A2","A3"],
  //   "cisco_threat_intel":["B1","B2","B3"]
  // }
  fieldList=[]
  threatFieldList=[]
  errorIndex=[]
  table_reference:any

  aggFunction=[
    {
      "disp":"Count",
      "value":"count"
    },
    {
      "disp":"Avg",
      "value":"average"
    },
    {
      "disp":"Sum",
      "value":"sum"
    },
    {
      "disp":"Min",
      "value":"min"
    },
    {
      "disp":"Max",
      "value":"max"
    },
    {
      "disp":"Count Distinct",
      "value":"count_distinct"
    }
    
  ]

  aggOperators=[
    {
      "disp":">",
      "value":">"
    },
    {
      "disp":">=",
      "value":">="
    },
    {
      "disp":"<",
      "value":"<"
    },
    {
      "disp":"<=",
      "value":"<="
    },
    {
      "disp":"=",
      "value":"="
    },
    {
      "disp":"Between",
      "value":"between"
    }
  ]

  retroPeriodData=[
    {
      "disp":"1 Hour",
      "value":3600
    },
    {
      "disp":"2 Hours",
      "value":7200
    },
    {
      "disp":"6 Hours",
      "value":21600
    },
    {
      "disp":"1 Day",
      "value":86400
    },
    {
      "disp":"2 Days",
      "value":172800
    }
  ]

  enrichFields=[]

  intelListEnrich=[]
//   intelListEnrich=[
//     {
//         "list_id": 10,
//         "list_name": "Test_list_3",
//         "platform": "all",
//         "ttl": 1123200,
//         "ttl_unit": 86400,
//         "learning_period": 259200,
//         "learning_unit": 86400,
//         "max_entry": 10000,
//         "total_rows": 1,
//         "referenced": false,
//         "created_time": "2025-11-27T10:37:44.81983",
//         "list_type": "Custom",
//         "fields":[
//           {
//             "fieldName":"action",
//             "type":"text"
//           }
//         ]
//     },
//     {
//         "list_id": 11,
//         "list_name": "Test_empty_list",
//         "platform": "all",
//         "ttl": 1123200,
//         "ttl_unit": 86400,
//         "learning_period": 259200,
//         "learning_unit": 86400,
//         "max_entry": 10000,
//         "total_rows": 2,
//         "referenced": false,
//         "created_time": "2025-11-27T10:37:44.819",
//         "list_type": "Custom",
//         "fields":[
//           {
//             "fieldName":"action",
//             "type":"text"
//           }
//         ]
//     },
//     {
//         "list_id": 9,
//         "list_name": "Test_list_2",
//         "platform": "all",
//         "ttl": 1036800,
//         "ttl_unit": 86400,
//         "learning_period": 172800,
//         "learning_unit": 86400,
//         "max_entry": 10000,
//         "total_rows": 1,
//         "referenced": false,
//         "created_time": "2025-11-27T08:19:01.461545",
//         "list_type": "Custom",
//         "fields":[
//           {
//             "fieldName":"reason",
//             "type":"text"
//           }
//         ]
//     },
//     {
//         "list_id": 8,
//         "list_name": "test_list",
//         "platform": "all",
//         "ttl": 864000,
//         "ttl_unit": 86400,
//         "learning_period": 172800,
//         "learning_unit": 86400,
//         "max_entry": 10000,
//         "total_rows": 2,
//         "referenced": false,
//         "created_time": "2025-11-27T05:54:50.538702",
//         "list_type": "Custom",
//         "fields":[
//           {
//             "fieldName":"action",
//             "type":"text"
//           },
//           {
//             "fieldName":"reason",
//             "type":"text"
//           }
//         ]
//     },
//     {
//         "list_id": 7,
//         "list_name": "Test_bad_ips",
//         "platform": "all",
//         "ttl": 8640000,
//         "ttl_unit": null,
//         "learning_period": null,
//         "learning_unit": null,
//         "max_entry": null,
//         "total_rows": 2026,
//         "referenced": false,
//         "created_time": "2025-11-17T17:33:15.769",
//         "list_type": "Custom",
//         "fields":[
//           {
//             "fieldName":"ip",
//             "type":"inet"
//           },
//           {
//             "fieldName":"country",
//             "type":"text"
//           }
//         ]
//     },
//     {
//         "list_id": 3,
//         "list_name": "hostile",
//         "platform": "all",
//         "ttl": 8640000,
//         "ttl_unit": null,
//         "learning_period": null,
//         "learning_unit": null,
//         "max_entry": null,
//         "total_rows": 5,
//         "referenced": false,
//         "created_time": "2025-08-05T17:33:15.769049",
//         "list_type": "Built-in",
//         "fields":[
//           {
//             "fieldName":"country",
//             "type":"text"
//           }
//         ]
//     },
//     {
//         "list_id": 1,
//         "list_name": "MyPrivate",
//         "platform": "all",
//         "ttl": 8640000,
//         "ttl_unit": null,
//         "learning_period": null,
//         "learning_unit": null,
//         "max_entry": null,
//         "total_rows": 4,
//         "referenced": true,
//         "created_time": "2025-08-05T17:33:15.769049",
//         "list_type": "Built-in",
//         "fields":[
//           {
//             "fieldName":"ip",
//             "type":"inet"
//           },
//           {
//             "fieldName":"country",
//             "type":"text"
//           }
//         ]
//     },
//     {
//         "list_id": 2,
//         "list_name": "MyPublic",
//         "platform": "all",
//         "ttl": 8640000,
//         "ttl_unit": null,
//         "learning_period": null,
//         "learning_unit": null,
//         "max_entry": null,
//         "total_rows": 6,
//         "referenced": true,
//         "created_time": "2025-08-05T17:33:15.769049",
//         "list_type": "Built-in",
//         "fields":[
//           {
//             "fieldName":"ip",
//             "type":"inet"
//           },
//           {
//             "fieldName":"country",
//             "type":"text"
//           }
//         ]
//     },
//     {
//         "list_id": 4,
//         "list_name": "CleartextPorts",
//         "platform": "all",
//         "ttl": 8640000,
//         "ttl_unit": null,
//         "learning_period": null,
//         "learning_unit": null,
//         "max_entry": null,
//         "total_rows": 16,
//         "referenced": false,
//         "created_time": "2025-08-05T17:33:15.769",
//         "list_type": "Built-in",
//         "fields":[
//           {
//             "fieldName":"port",
//             "type":"number"
//           }
//         ]
//     },
//     {
//         "list_id": 5,
//         "list_name": "CleartextService",
//         "platform": "all",
//         "ttl": 8640000,
//         "ttl_unit": null,
//         "learning_period": null,
//         "learning_unit": null,
//         "max_entry": null,
//         "total_rows": 2,
//         "referenced": false,
//         "created_time": "2025-08-05T17:33:15.769",
//         "list_type": "Built-in",
//         "fields":[
//           {
//             "fieldName":"service",
//             "type":"text"
//           }
//         ]
//     },
//     {
//         "list_id": 6,
//         "list_name": "RareCountries",
//         "platform": "all",
//         "ttl": 8640000,
//         "ttl_unit": null,
//         "learning_period": null,
//         "learning_unit": null,
//         "max_entry": null,
//         "total_rows": 6,
//         "referenced": false,
//         "created_time": "2025-08-05T17:33:15.769",
//         "list_type": "Custom",
//         "fields":[
//           {
//             "fieldName":"country",
//             "type":"text"
//           }
//         ]
//     }
// ]

communicationMethods=[
  {
    "disp":"Phone",
    "value":"phone"
  },
  {
    "disp":"E-mail",
    "value":"email"
  }
]

  stepsizeDisable:boolean=false

  agg_fieldDisable=[true]

  agg_fieldsList=[]

  total_agg_fields=JSON.parse(JSON.stringify(this.sharedService.commonPlatformFields))

  

  

  ruleForm = new FormGroup({
    // getEditor:new FormControl(''),
    // actionchip:new FormControl(''),

    context: new FormGroup({
      ruleName: new FormControl('',{
        validators: [Validators.required, Validators.maxLength(200), VerifyRuleName()],
        asyncValidators: [RulenameValidator.createValidator(this.ruleservice,this.editState)]
      }),
      ruleDescription: new FormControl('',{
        validators:[Validators.maxLength(1000)]
      }),
      // status: new FormControl(),
      // platform: new FormControl(''),
      // ruleType: new FormControl(''),
      severity: new FormControl(''),
      knowledgebase: new FormControl('',{
        validators:[Validators.maxLength(1000)]
      }),
      falsePositive: new FormControl('', {
        validators:[Validators.maxLength(1000)]
      }),
      url:new FormControl('', {
        validators:[Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6}).*'), Validators.maxLength(2000)]
      }),
      providersource: new FormControl(''),
      providerId: new FormControl('', {
        validators:[Validators.maxLength(100)]
      })
    }),
    ruleConditions: new FormGroup({
      queries : new FormGroup({
        query1 : new FormGroup({
          query: new FormControl(''),
          timeframe: new FormControl(),
          stepsize:new FormControl()
        }),
      }),
      // aggregationCondition: new FormGroup({
      //   pivotFields: new FormControl(),
      //   aggregateFunction: new FormControl(),
      //   aggregateFunctionField: new FormControl(),
      //   thresholdOperator: new FormControl(),
      //   thresholdValue:new FormControl(null),
      //   aggregateTime: new FormControl(),
      //   aggregateTimeUnit: new FormControl()
      // }),
      platform: new FormControl(''),
      impactedHost: new FormControl(null,{
        validators:[VerifyImpactedHost()]
      }),
      ruleType: new FormControl(''),
      // getEditor:new FormControl(''),

      triggers : new FormGroup({
        threshold: new FormControl('',[Validators.required]),
        field: new FormControl('',[Validators.required]),
        timevalue: new FormControl('', [Validators.max(this.newtermLimit),Validators.required]),
        timeunit: new FormControl('',[Validators.required]),
        remove: new FormControl(false),
        list_id:new FormControl(),
        listname:new FormControl(),
        unique: new FormControl(true),
        list: new FormGroup({}),
        threat_intel_provider: new FormControl('',[Validators.required]),
        threat_intel: new FormArray([
          this.addNewCond()
          ]),
          aggregation : new FormGroup({
            group_fields: new FormControl('',[Validators.required]),
            sliding: new FormControl(false),
           conditions: new FormArray([
            this.addNewAgg()
           ]),
            dynamic_threshold: new FormControl(true),
            threshold: new FormControl('',[Validators.required])
          })
      }),
     
       
      
    }),
    actions:new FormGroup({
      entity_map:new FormArray([
        // this.addNewEntity()
      ]),
      enrich:new FormArray([]),
      // phantom_mode: new FormControl(false),
      // add_tags: new FormGroup({}),
      manage_list: new FormGroup({
        list_id: new FormControl(),
        unique: new FormControl(),
        remove:new FormControl(),
        list: new FormGroup({
        })
      }),
      communications: new FormGroup({
        method : new FormControl(),
        phone: new FormGroup({
          country_code: new FormControl('+91'),
          number: new FormControl(),
          message: new FormControl()
        }),
        email: new FormGroup({
          mail_id: new FormControl(),
          subject: new FormControl(),
          mail_body: new FormControl()
        })
      })
    }),

    advanced: new FormGroup({
      alertType: new FormControl(''),
    }) ,
    schedule: new FormControl(''),
  })

  phoneNumberValidation(): ValidatorFn{
    return (control: AbstractControl) => {
      const regex = /^[6-9]\d{9}$/;
      if (!control.value) return null;
      return regex.test(control.value) ? null : { numberError: true };
    };
  }

  emailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) return null; 
  
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
      const valid = regex.test(control.value);
  
      return valid ? null : { emailError: true };
    };
  }

  textValidator(allowNull?): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;


      if (!value) {
        if(allowNull){
          return null; 
        }else{
          return {required:true}
        }
      }
  
      const regex = /$/;
  
      return regex.test(value)
        ? null
        : { textError: true };
    };
  }

  numberValidator(allowNull?):ValidatorFn{
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!value) {
        if(allowNull){
          return null; 
        }else{
          return {required:true}
        }
      }
  
      const regex = /^[0-9]+$/;
  
      return regex.test(value)
        ? null
        : { numberError: true };
    };
  }

  ipValidator(allowNull?): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
  
      if (!value) {
        if(allowNull){
          return null; 
        }else{
          return {required:true}
        }
      }
  
      const ipv4Regex =
        /^(25[0-5]|2[0-4]\d|1?\d?\d)(\.(25[0-5]|2[0-4]\d|1?\d?\d)){3}$/;
  
      return ipv4Regex.test(value)
        ? null
        : { ipError: true };
    };
  }

  defaultListTemp={
    "list": {
    },
    "remove": false,
    "unique": true,
    "list_id": ''
}

  get_list(){
    return this.getaction().get('manage_list').get('list') as UntypedFormGroup
  }

  get_entity(){
    return this.getaction().get('entity_map') as UntypedFormArray
  }

  get_enrich(){
    return this.getaction().get('enrich') as UntypedFormArray
  }

  addNewEnrichField(){
    const group=new FormGroup({
      listName:new FormControl(),
      listField:new FormControl(),
      alertField:new FormControl('',[Validators.required, this.enrichExistsCheck() ]),
      mappedAlertField: new FormControl('',Validators.required),
      mappedFieldAlias: new FormControl('',Validators.required)
    })
    group.get('alertField').valueChanges.pipe(distinctUntilChanged()).subscribe(data=>{
      this.enrichAlertFieldValChanges(group,data)
    })
    group.get('mappedAlertField').valueChanges.pipe(distinctUntilChanged()).subscribe(data=>{
      this.enrichMappedAlertFieldValChanges(group,data)
    })
    group.get('mappedFieldAlias').valueChanges.pipe(distinctUntilChanged()).subscribe(data=>{
      this.mappedFieldAliasValChanges(group,data)
    })
    return group
  }

  mappedFieldAliasValChanges(group,data){
    // console.log({data})
    // console.log(group.get('mappedFieldAlias').value)
    // console.log(group.value.mappedFieldAlias)
    const listFieldValues = this.showEnrichFields.map(f => f.disp);
    let index =this.showEnrichFields.findIndex(val=>val.disp == group.value.mappedFieldAlias)
//console.log(this.showAlertFields)
//console.log(this.showAlertFields[index])
//console.log(index)
    if(index != -1){
      this.showEnrichFields.splice(index,1)
    }
//console.log(this.showAlertFields)
    if(listFieldValues.includes(data)){
      // console.log({data})
      // console.log(group.get('mappedFieldAlias').value)
      
    }else{
      // console.log({data})
      // console.log(group.get('mappedFieldAlias').value)
      this.enrichFields.forEach(key=>{
        if(key.disp === group.get('listName').value){
          // console.log(key)
          key.value.forEach(val=>{
            if(val.disp === group.get('mappedAlertField').value){
              // this.listFields.push({"disp":data,"value":data,"type":val.type})
              this.showEnrichFields.push({"disp":data,"value":data,"type":val.type})
            }
          })
        }
      })
    }
    // console.log({data})
    // console.log(this.listFields)
    // console.log(this.showAlertFields)
    group.get('mappedFieldAlias').setValidators([Validators.required,this.mappedFieldAliasValidator()]);
    group.get('mappedFieldAlias').updateValueAndValidity({emitEvent:false})

  }

  enrichAlertFieldValChanges(group,data){
//console.log({group})
//console.log(this.get_enrich().controls.indexOf(group))
    
    let array=this.get_enrich() as UntypedFormArray
    setTimeout(() => {
      if(array.valid){
        this.actions.enrich.state=1
      }else{
        this.actions.enrich.state=-1
      }
    }, 0);    

    group.get('alertField').setValidators([this.enrichAlertFieldTypeValidators(group,data),this.enrichExistsCheck()]);
    group.get('alertField').updateValueAndValidity({ emitEvent: false });
  }
  enrichMappedAlertFieldValChanges(group,data){
//console.log(group.value)
    //console.log(this.get_enrich().controls.indexOf(group))
//console.log({data})
//console.log(this.enrichFields)
    // console.log(group.get('mappedFieldAlias'))
    if(group.get('mappedFieldAlias').pristine){
      group.get('mappedFieldAlias').setValue(group.value.listName+"_"+data)
    }

    
    let array=this.get_enrich() as UntypedFormArray
    setTimeout(() => {
      if(array.valid){
        this.actions.enrich.state=1
      }else{
        this.actions.enrich.state=-1
      }
    }, 0);    

    group.get('mappedAlertField').setValidators([this.enrichValidator(group)]);
    group.get('mappedAlertField').updateValueAndValidity({ emitEvent: false });
  }

  mappedFieldAliasValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const array = this.ruleForm.get('actions').get('enrich') as UntypedFormArray;
  
      const values = array.controls
        .map(c => c.get('mappedFieldAlias')?.value)
        .filter(v => v);
  
      const hasDuplicate = values.some(
        (v, i) => values.indexOf(v) !== i
      );

      const listFieldValues = this.listFields.map(f => f.value);
      const existsInListFields = values.some(v =>
        listFieldValues.includes(v)
      );
  
      return (hasDuplicate || existsInListFields)
      ? { nonUniqueValue: true }
      : null;
    };
  }

  enrichExistsCheck(): ValidatorFn{
    return (control: AbstractControl): ValidationErrors | null => {
      // console.log(control)
      let isExists=false
      if(this.listFields.length){
        this.listFields.forEach(list=>{
          // console.log({list})
          if(list.value === control.value){
            isExists=true
          }
        })
      }else{
        isExists=false
      }
      // console.log({isExists})
      return isExists ? null : {exists:true}
    }
  }
  

  enrichAlertFieldTypeValidators(group,data): ValidatorFn{
//console.log({data})
    if(this.editState){
      // this.changePlatformFields(this.editrequested.value.ruleConditions.platform)
    }
    // console.log(this.listFields)
    return (control: AbstractControl): ValidationErrors | null => {
      let valid=false
      let index=this.listFields.findIndex(dat=>dat.value===data)
      let enrichIndex
      // let check=true
      // console.log(group.get('alertField'))
      // if(group.get('alertField').errors){
      //   Object.keys(group.get('alertField').errors).forEach(err=>{
      //     if(err == "exists"){
      //       check=false
      //     }
      //   })
      // }
//console.log(group.get('alertField').errors)
      // if(check){
        this.enrichFields.forEach(list=>{
          if(list.disp === group.get('listName').value){
            enrichIndex=list.value.findIndex(dat=>dat.disp == group.get('listField').value)
            if(this.listFields[index]?.type === list.value[enrichIndex].type){
            valid =true
            }else{
              valid = false
            }
          }
        })
      // }else{
      //   valid=true
      // }
      return valid ? null : { typeError: true };
    };
    
  }

  enrichValidator(group): ValidatorFn{
    return (control: AbstractControl): ValidationErrors | null => {
      let index=this.get_enrich().controls.indexOf(group)
      let valid=true
      Object.keys(this.get_enrich().controls).forEach(key=>{
        if(parseInt(key) != index){
            if(this.get_enrich().get(key.toString()).get('listName').value===group.get('listName').value && this.get_enrich().get(key.toString()).get('mappedAlertField').value===group.get('mappedAlertField').value){
              valid=false
            }
          
        }
      })
      return valid ? null : { alreadyExists: true };
    };
  }

  addNewEntity(){
    const group=new FormGroup({
      entity:new FormControl('',Validators.required),
      entityField:new FormControl('',Validators.required),
      alertField:new FormControl('',Validators.required)
    })
    group.get('alertField').valueChanges.pipe(distinctUntilChanged()).subscribe(data=>{
      this.alertFieldValChanges(group,data)
    })
    return group
  }

  alertFieldValChanges(group,data){
//console.log({group})
//console.log(this.get_entity().controls.indexOf(group))
    // if(group.valid){
    //   this.actions.alert_fields.state=1
    // }else{
    //   this.actions.alert_fields.state=-1
    // }
    let array=this.get_entity() as UntypedFormArray
    setTimeout(() => {
      if(array.valid){
        this.actions.alert_fields.state=1
      }else{
        this.actions.alert_fields.state=-1
      }
    }, 0);    
    // let index=this.listFields.findIndex(dat=>dat.value===data)
    // console.log(this.listFields[index])
    // console.log(group.get('entityField').value,"-->",this.entityList)
    // let entityIndex=this.entityList.findIndex(dat=>dat.disp==group.get('entityField').value)
    // console.log(this.entityList[entityIndex])

    // let index=this.get_entity().controls.indexOf(group)
    // Object.keys(this.get_entity().controls).forEach(key=>{
    //   if(parseInt(key) != index){
    //     if(this.get_entity().get(key.toString()).get('entity').value===group.get('entity').value && this.get_entity().get(key.toString()).get('entityField').value===group.get('entityField').value){
    //       if(this.get_entity().get(key.toString()).get('alertField').value===group.get('alertField').value){
    //         console.log(this.get_entity().get(key.toString()).get('alertField').value,"-->",group.get('alertField').value)
    //         console.log("Exists")
    //       }
    //     }
    //   }
    // })

    group.get('alertField').setValidators([this.alertFieldTypeValidators(group,data),this.entityValidator(group)]);
    group.get('alertField').updateValueAndValidity({ emitEvent: false });
  }

  alertFieldTypeValidators(group,data): ValidatorFn{
    return (control: AbstractControl): ValidationErrors | null => {
      let valid=false
      let index=this.listFields.findIndex(dat=>dat.value===data)
//console.log(this.listFields[index])
// console.log(group.get('entityField').value,"-->",this.entityList)
      let entityIndex=this.entityList.findIndex(dat=>dat.disp==group.get('entityField').value)
      // console.log(this.entityList[entityIndex])
      if(this.entityList[entityIndex]){
        if(this.listFields[index]?.type === this.entityList[entityIndex].type){
          valid =true
        }else{
          valid = false
        }
      }else{
        valid =true
      }
      return valid ? null : { typeError: true };
    };
    
  }

  entityValidator(group): ValidatorFn{
    return (control: AbstractControl): ValidationErrors | null => {
      let index=this.get_entity().controls.indexOf(group)
      let valid=true
      Object.keys(this.get_entity().controls).forEach(key=>{
        if(parseInt(key) != index){
          if(this.get_entity().get(key.toString()).get('entity').value===group.get('entity').value && this.get_entity().get(key.toString()).get('entityField').value===group.get('entityField').value){
            if(this.get_entity().get(key.toString()).get('alertField').value===group.get('alertField').value){
              // console.log(this.get_entity().get(key.toString()).get('alertField').value,"-->",group.get('alertField').value)
              valid=false
            }
          }
        }
      })
      return valid ? null : { alreadyExists: true };
    };
  }

  async changePlatformFields(platform){
    // console.log(this.platform.value)
    await this.fetchPlatformFieldsOnEdit(platform)
    .then((platformfields: any) => {
//console.log({platformfields})
      if (platformfields.platform_fields) {
        this.fieldsList = this.commonFieldsEntityCheck(JSON.parse(JSON.stringify(platformfields.platform_fields)));
        this.total_agg_fields=this.commonFieldsEntityCheck(JSON.parse(JSON.stringify(platformfields.platform_fields)));
        this.totalPlatformFields=this.commonFieldsEntityCheck(JSON.parse(JSON.stringify(platformfields.platform_fields)));
        // this.totalPlatformFields=this.rulevarservice.commonFieldsEntityCheck(JSON.parse(JSON.stringify(platformfields.platform_fields)));
        this.listFields=this.commonFieldsEntityCheck(JSON.parse(JSON.stringify(platformfields.platform_fields)));

      }
    })
  }

  fetchPlatformFieldsOnEdit(platform: string) {
    return this.assetsService.getCommonPlatformFields({ 'platform': platform }).toPromise()
  }

 

  actionListNames=[]

  async getActionListNames(){
    await this.fetchIntelListName()
      .then((value: any) => {
        this.actionListNames=[]
        this.actionListNames = value;
//console.log({value})
        if(this.editState){
          // this.getaction().get('manage_list').get('list_id').setValue(this.editrequested.value.actions.manage_list.list_id)
        }
        else{
          // this.getaction().get('manage_list').get('list_id').setValue(this.actionListNames[0].value)
        }
      })
  }

  buildListForm(list){
    this.listDataTypeError={}
    Object.keys(list).forEach(key=>{
      
        this.get_list().addControl(key, new FormControl(''))
        this.listDataTypeError[key]=false
        
        this.get_list().get(key.toString()).setValue('')
        this.get_list().get(key.toString()).valueChanges.pipe(distinctUntilChanged()).subscribe(val=>{
          this.listFieldValueChanges(this.get_list().get(key.toString()),val,key)
        })
        this.actions.manage_list.state=0
      if(this.editState){
//console.log("Data in Edit ----->",this.editrequested.value.actions.manage_list.list[key])
        // this.get_list().get(key.toString()).setValue(this.editrequested.value.actions.manage_list.list[key])
      }
//console.log({key})
//console.log(this.get_list())
    })
    //  if(this.get_list().valid){
    //       this.actions.manage_list.state=1
    //     }else{
    //       this.actions.manage_list.state=-1
    //     }
  }
  listFieldValueChanges(group,val,key){
    // console.log({group})
    // console.log({val})
    // console.log({key})
    Object.keys(this.actionList).forEach(dat=>{
      // console.log({dat})
      if(dat === "list"){
        // console.log(this.actionList[dat][key])

        let index=this.listFields.findIndex(obj=>obj.disp == val)
//console.log("ListFields ------>",this.listFields)
        
          if(this.listFields[index]?.type && this.actionList[dat][key]?.type){
//console.log("Value",this.listFields[index])
//console.log("Value",this.listFields[index].type)
//console.log("Value with type -----> ",this.listFields[index].type)
//console.log("Field Value with type -----> ",this.actionList[dat][key].type)
            if(this.listFields[index]?.type == this.actionList[dat][key]?.type){
              // Object.keys(this.listDataTypeError).forEach(data=>{
              //   this.listDataTypeError[data][key]=false
              //   console.log(this.listDataTypeError[data][key])
              // })
              this.listDataTypeError[key]=false
              this.actions.manage_list.state=1
              
              this.ruleForm.get('actions').get('manage_list').setErrors(null)
              this.ruleForm.get('actions').get('manage_list').updateValueAndValidity()
            }
            else{
              this.listDataTypeError[key]=true
              this.actions.manage_list.state=-1
             group.setErrors({required:true})
              // this.ruleForm.get('actions').get('manage_list').updateValueAndValidity()
//console.log(this.ruleForm.get('actions').get('manage_list').valid)
              // Object.keys(this.listDataTypeError).forEach(data=>{
              //   this.listDataTypeError[data][key]=true
              //   console.log(this.listDataTypeError[data][key])
              // })
            }
          }
          
      }
    })
    // console.log("DataType Error ------->",this.listDataTypeError)
   
  }
  manage_listFieldsCheck(){ // Remove manage_list fields that is not in query
    // console.log(this.totalFields)
    Object.keys(this.get_list().value).forEach(key=>{
      let field=this.get_list().get(key.toString()).value
      this.get_list().get(key.toString()).reset()
      // console.log({key})
      // console.log(this.get_list().get(key.toString()).value)
      Object.keys(this.totalFields).forEach(val=>{
        if(this.totalFields[val].image === field){
          this.get_list().get(key.toString()).setValue(field)
        }
      })
    })
  }
  
  


  

  addNewAgg(){
    const group = new FormGroup({
      aggregate_function: new FormControl('',[Validators.required]),
      aggregate_field: new FormControl('',[Validators.required]),
      operator: new FormControl('',[Validators.required]),
      number_field_1: new FormControl('',[Validators.required]),
      number_field_2: new FormControl('',[Validators.required]),
    })
    group.get("aggregate_field").disable()
    group.get('aggregate_function')!.valueChanges.subscribe((selectedField: string) => {
      this.agg_func_valueChanges(group, selectedField);
    });

    group.get('aggregate_field')!.valueChanges.subscribe((selectedField: string) => {
      this.agg_field_valueChanges(group, selectedField);
    });

    group.get('operator')!.valueChanges.subscribe((selectedField: string) => {
      this.operator_valueChanges(group, selectedField);
    });

    return group
  }

  addNewCond(){
    const group = new FormGroup({
      actions: new FormGroup({
        query_field: new FormControl('',[Validators.required]),
        operator: new FormControl('',[Validators.required]),
        intel_field: new FormControl('',[Validators.required]),
      })
    });

    // group.get('actions').get('query_field')!.valueChanges.subscribe(val=>{
    //   this.queryFieldValChanges(group,val)
    //   // console.log({val})
    // })

   
    return group
  }
  // queryFieldValChanges(group,val){ // Disable selected queryfields
  
  //  let queryList=[] 
  //  Object.keys(this.ruleForm.get('ruleConditions').get('triggers').get('threat_intel').value).forEach(key=>{
  //   if(this.ruleForm.get('ruleConditions').get('triggers').get('threat_intel').get(key.toString()).get('actions').get('query_field').value){
  //     queryList.push(this.ruleForm.get('ruleConditions').get('triggers').get('threat_intel').get(key.toString()).get('actions').get('query_field').value)
  //   }
  //  })
  //   const checkSet = new Set(queryList);
  //   console.log({checkSet})
    
  //   this.fieldList = this.fieldList.map(obj => ({
  //     ...obj,
  //     status: checkSet.has(obj.value) ? 0 : 1
  //   }));
  //   console.log(this.fieldList)
  // }


  fieldsList=[]

  value='Value'

  queryHasTokens:boolean=false

  

  agg_func_valueChanges(group,selectedField){
    if(this.queryHasTokens){
      if(!this.ruleForm.get('ruleConditions').get('triggers').get('aggregation').get('threshold').valid){
        this.triggers_error=true
      }
    }else{
      if(!this.ruleForm.get('ruleConditions').get('triggers').get('aggregation').valid){
        this.triggers_error=true
      }
    }
    // console.log(group)
    // console.log({selectedField})
//console.table(this.total_agg_fields)
    let empty=null
    group.get('aggregate_field').enable()
    // group.get('aggregate_field').setValue(empty)
    if(selectedField === 'sum' || selectedField === 'average' || selectedField === 'min' || selectedField === 'max'){
    this.agg_fieldsList=[]
      // Object.keys(this.total_agg_fields).forEach(key=>{
      //   if(this.total_agg_fields[key].display_type === "number"){
      //     this.agg_fieldsList.push(this.total_agg_fields[key])
      //   }
      // })

      Object.keys(this.fieldsList).forEach(key=>{
        if(this.fieldsList[key].display_type === "number"){
          this.agg_fieldsList.push(this.fieldsList[key])
        }
      })

    }
    if(selectedField === 'count'){
      group.get('aggregate_field').setValidators(null)
      group.get('aggregate_field').updateValueAndValidity
      
    }
    else{
      group.get('aggregate_field').setValidators(Validators.required)
      group.get('aggregate_field').updateValueAndValidity
    }
    group.get('aggregate_field').setValue(empty)

    
//console.table(this.agg_fieldsList)
    // else{
      // this.agg_fieldsList=this.fieldsList
    // }
    // if(group.get('aggregate_field').value){
      
      
    //   this.queryVerified=true
    //   this.platformFields=[]
    //   this.fields=[]
    //   this.totalFields=[]
    //   Object.keys(this.fieldsList).forEach(key=>{
    //     Object.keys(this.ruleForm.get('ruleConditions').get('triggers').get('aggregation').get('group_fields').value).forEach(val=>{
    //       if(this.fieldsList[key].value == this.ruleForm.get('ruleConditions').get('triggers').get('aggregation').get('group_fields').value[val]){
    //         this.fields.push({"image":this.ruleForm.get('ruleConditions').get('triggers').get('aggregation').get('group_fields').value[val],"cat":this.ruleForm.get('ruleConditions').get('triggers').get('aggregation').get('group_fields').value[val],"type":this.fieldsList[key].display_type})
    //         this.totalFields.push({"image":this.ruleForm.get('ruleConditions').get('triggers').get('aggregation').get('group_fields').value[val],"cat":this.ruleForm.get('ruleConditions').get('triggers').get('aggregation').get('group_fields').value[val],"type":this.fieldsList[key].display_type})
    //         console.log("Fields",this.fields)
    //       }
    //     })
       
    //   })
    //   let alias=group.get('aggregate_function').value + "_" + group.get('aggregate_field').value
    //   console.log({alias})
    //   this.fields.push({"image":alias,"cat":alias,"type":"number"})
    //   this.totalFields.push({"image":alias,"cat":alias,"type":"number"})
    //   this.fields = Array.from(new Map(this.fields.map(obj => [obj.image, obj])).values());
    //   this.totalFields = Array.from(new Map(this.totalFields.map(obj => [obj.image, obj])).values());
    //   this.platformFields=this.fields
    //   this.setActionFields('firewall_fortigate')  
    // }
  }
  agg_field_valueChanges(group, selectedField){
    if(this.queryHasTokens){
      if(!this.ruleForm.get('ruleConditions').get('triggers').get('aggregation').get('threshold').valid){
        this.triggers_error=true
      }
    }else{
      if(!this.ruleForm.get('ruleConditions').get('triggers').get('aggregation').valid){
        this.triggers_error=true
      }
    }

//console.log({selectedField})

    if(!this.queryHasTokens){
      if(selectedField){
        this.queryVerified=true
        this.platformFields=[]
        this.fields=[]
        this.totalFields=[]
        if(this.fieldList && this.ruleForm.get('ruleConditions').get('triggers').get('aggregation').get('group_fields').value){
          Object.keys(this.fieldsList).forEach(key=>{
            Object.keys(this.ruleForm.get('ruleConditions').get('triggers').get('aggregation').get('group_fields').value).forEach(val=>{
              if(this.fieldsList[key].value == this.ruleForm.get('ruleConditions').get('triggers').get('aggregation').get('group_fields').value[val]){
                this.fields.push({"image":this.ruleForm.get('ruleConditions').get('triggers').get('aggregation').get('group_fields').value[val],"cat":"field","type":this.fieldsList[key].type})
                this.totalFields.push({"image":this.ruleForm.get('ruleConditions').get('triggers').get('aggregation').get('group_fields').value[val],"cat":"field","type":this.fieldsList[key].type})
//console.log("Fields",this.fields)
              }
            })
          })
        }
        Object.keys(this.ruleForm.get('ruleConditions').get('triggers').get('aggregation').get('conditions').value).forEach(key=>{
          if(group.get('aggregate_function').value && group.get('aggregate_field').value){
            let alias=this.ruleForm.get('ruleConditions').get('triggers').get('aggregation').get('conditions').get(key.toString()).get('aggregate_function').value + "_" + this.ruleForm.get('ruleConditions').get('triggers').get('aggregation').get('conditions').get(key.toString()).get('aggregate_field').value
//console.log({alias})
            this.fields.push({"image":alias,"cat":"tablecolumn","type":"number"})
            this.totalFields.push({"image":alias,"cat":"tablecolumn","type":"number"})
          }
        })
        
        this.fields = Array.from(new Map(this.fields.map(obj => [obj.image, obj])).values());
        this.totalFields = Array.from(new Map(this.totalFields.map(obj => [obj.image, obj])).values());
        this.platformFields=this.fields
        this.setActionFields('firewall_fortigate')  
      }
    }

  }
  operator_valueChanges(group, selectedField){
    if(this.queryHasTokens){
      if(!this.ruleForm.get('ruleConditions').get('triggers').get('aggregation').get('threshold').valid){
        this.triggers_error=true
      }
    }else{
      if(!this.ruleForm.get('ruleConditions').get('triggers').get('aggregation').valid){
        this.triggers_error=true
      }
    }

    if(selectedField!= 'between'){
      this.value='Value'
      group.get('number_field_2').setValue('')
      group.get('number_field_2').clearValidators()
      group.get('number_field_2').updateValueAndValidity()
    }
    else{
      this.value='Value 1'
      group.get('number_field_2').setValidators([Validators.required])
      group.get('number_field_2').updateValueAndValidity()
    }
  }

  commonFieldsEntityCheck(array:[]){
    // console.log({array})
    let fields=[]
    Object.keys(array).forEach(key=>{
      if(array[key].is_entity){
        fields.push(array[key])
      }
    })
    return fields
  }

  preprocess = this.rulepreprocess();

  processPlatformFields(platformfields:any[]){
    this.platformFields.length = 0;
    for (let i = 0; i < platformfields.length; i++) {
      if (platformfields[i].is_view) {
        this.platformFields.push(platformfields[i]);
      }
    } 
    const newplatformfields = [];
    for(let i=0; i<this.platformFields.length; i++){
      const newobj = {...platformfields[i]}
      newobj['value'] = [platformfields[i]['value'],platformfields[i]['display_type'],platformfields[i]['value']];
      newplatformfields.push(newobj);
    }
    this.eventFieldOptions = [...newplatformfields];
  }

  tagsMapping(tagsdata:any) {
    for (let tag in tagsdata) {
      this.distag[tag] = [];
    }
  }

  tagsSearch(val: string) {
    this.commonData.tags.tagslist.forEach((ele: any) => {
      const searchterm: string = ele.disp;
      if (searchterm.toLowerCase().includes(val.toLowerCase())) {
        this.distag[ele.parent].push(ele);
      }
    })
  }

  tagsActionMapping(tagsdata:any) {
    // for (let tag in tagsdata) {
      this.actions.alert_fields.fields_list.field[tagsdata] = [];
    // }
  }

  tagsActionSearch(val: string) {
    this.actionFields.forEach((ele: any) => {
      const searchterm: string = ele.disp;
      if (searchterm.toLowerCase().includes(val.toLowerCase())) {
        this.actions.alert_fields.fields_list.field[ele.parent].push(ele);
      }
    })
  }
  

  getcontext(){
    return this.ruleForm.controls['context'] as FormGroup
  }
  getaction(){
    return this.ruleForm.get('actions') as FormGroup
  }
  // getaddTags(){
  //   return this.ruleForm.get('actions').get('add_tags') as FormGroup
  // }
  

  platformfieldpreprocess(){
    const host = this.sharedService.hostlist;
//console.log("Platformfieldpreprocess---->",host)
    this.processPlatformFields(JSON.parse(JSON.stringify(this.sharedService.commonPlatformFields)));
    // this.ruleMeta.ruledefault.context.impactedHost.uniqueHostsLength = 1;
    // this.ruleMeta.ruledefault.context.impactedHost.selectedHosts = [host[0]];
    this.ruleMeta.ruledefault.context.impactedHost.uniqueHostsLength = host.length
    this.ruleMeta.ruledefault.context.impactedHost.selectedHosts = host;
//console.log("MockMeta ------>",this.mockmeta)
  }

  rulepreprocess(){
    // console.log("PreProcess>>>>>>>>>",this.ruleMeta.ruledefault)
    this.platformfieldpreprocess();
    // for(let i=0; i<this.commonData.tags.tagslist.length; i++){
    //   this.tagmapping[this.commonData.tags.tagslist[i]["val"]] = this.commonData.tags.tagslist[i];
    // }
    // this.tagsMapping(this.commonData.tags.mapping);
    // this.tagsSearch('');
    // this.getaddTags().addControl('tags', this.structureTagsService.createTagControl(this.distag));
    // this.getaction().addControl('tagsaction', this.structureTagsService.createTagControl(this.actions.alert_fields.fields_list.field));
    // this.ruleForm.patchValue(this.ruleMeta.ruledefault);
    // console.log("Distag",this.distag,"\n Fields",this.actions.alert_fields.fields_list.field)
    this.ruleForm.patchValue(this.mockmeta);

  }
  createrulepreprocess(){
    // this.platformfieldpreprocess();
    for(let i=0; i<this.commonData.tags.tagslist.length; i++){
      this.tagmapping[this.commonData.tags.tagslist[i]["val"]] = this.commonData.tags.tagslist[i];
    }
    this.tagsMapping(this.commonData.tags.mapping);
    this.tagsSearch('');
    // this.getaddTags().addControl('tags', this.structureTagsService.createTagControl(this.distag));
    // this.createActionTagControls()
//console.log(this.getaction())
    // this.ruleForm.patchValue(this.ruleMeta.ruledefault);
//console.log("Distag",this.distag,"\n Fields",this.actions.alert_fields.fields_list.field)
    this.ruleForm.patchValue(this.mockmeta);
  }
  createActionTagControls(){
    let group=this.getaction().addControl('tagsaction', this.structureTagsService.createTagControl(this.actions.alert_fields.fields_list.field));
    // console.log("-->",this.getaction().get('tagsaction'))
    this.getaction().get('tagsaction').valueChanges.pipe(distinctUntilChanged()).subscribe(data=>{
      this.tagsActionValChanges(data)
    })
    return group
  }
  serviceSelectedList=[]
  serviceActionSelected:boolean=false
  serviceActionChips={}
  public _tagAction = new BehaviorSubject<string | null>(null);
  public $tagAction = this._tagAction.asObservable();

  tagsActionValChanges(data){
    this.serviceSelectedList=data
    this.tagValueChanges(data)
//console.log({data})

  }
  tagValueChanges(value) {
    this._tagAction.next(value);
  }


  resetrulelist(){
    this.ruleList.length = this.filteredruleList.length = 
    this.ruleActiveList.length=this.filteredruleList.length=
    this.lookbacklist.length = this.eventFieldOptions.length = 
    this.ruleselectedIndex = 0;
    this.ruleStat = null;

    this.ruletablesearch.setValue('');
    this.rulerepotablesearch.setValue('');
    this.ruleitemperpage.setValue(this.ruleMeta.paginationDefault.itemPerPage);
    this.rulerepoitemperpage.setValue(this.ruleMeta.paginationDefault.itemPerPage);
    this.intelitemperpage.setValue(this.ruleMeta.paginationDefault.itemPerPage);
    this.lookbackitemperpage.setValue(this.ruleMeta.paginationDefault.itemPerPage);

    this.rulepagenumber = this.rulepagelength 
    this.rulerepopagenumber = this.rulerepopagelength 
    this.intelpagelength = this.intelpagelength
    this.lookbackpagenumber = this.lookbackpagelength = 1;
  }

  resetrulefrom(){
    this.errorState = new Array(3).fill(false);
    this.selectedIndex = 0;
    this.editSend = {}
    this.editState = false;
    this.tagmapping = {};
    this.distag = {};
    this.tagsSet.clear();
    this.actions=JSON.parse(JSON.stringify(this.defaultAction))
  }

  resetUser(){
    this.resetrulelist();
    this.resetrulefrom();
    this.ruleservice.customerChangeLogggedOff.next(true);
  }

  //generate engine execute and exempt
  timeWindowMeta = {
    metaDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    metaTime: ["00:00:00", "23:59:59"]
  }

  favourites = {
    meta: this.timeWindowMeta,
    handleTime(timedat: any, val: number) {
        if(val - 1) {
          return {
            customizedDays: { non_businessdays: 'non_businessdays' },
            customizedTime: { non_businesstime: 'non_businesstime' },
            "include": !timedat.alertsOn
          }
        } else {
          return {
            customizedDays: { businessdays: 'businessdays' },
            customizedTime: { businesstime: 'businesstime' },
            "include": !timedat.alertsOn
          }
        }
    }
  }

  customizedDays = {

    meta: this.timeWindowMeta,
    handleCustomizedTime(timedat: any, val: number) {
        if (val - 1 == 1) {
            return { "time_range": [timedat.timeRangeStart + ':00', timedat.timeRangeEnd + ':00'] }
        } else {
            return { "time_range": this.meta.metaTime }
        }
    },
    handleDate(dates: any) {
        return dates;
    },

    handleDays(days: any) {
        let filteredDays = []
        for (let i = 0; i < days.length; i++) {
            if (days[i]) {
                filteredDays.push(this.meta.metaDays[i])
            }
        }
        return filteredDays;
    },

    handleTime(timedat: any, val: number) {
          if(val - 1 == 1) {
          return {
            "customizedDays": { days_of_the_week: this.meta.metaDays.slice(-2) },
            "customizedTime": this.handleCustomizedTime(timedat, timedat.customizedTime),
            "include": !timedat.alertsOn
          }
        } else if (val - 1 == 2) {
            return {
              "customizedDays": { days_of_the_week: this.handleDays(timedat.days) },
              "customizedTime": this.handleCustomizedTime(timedat, timedat.customizedTime),
              "include": !timedat.alertsOn
            }
        }
        else if (val - 1 == 3) {
          return {
            "customizedDays": { days_of_the_month: this.handleDate(timedat.dates) },
            "customizedTime": this.handleCustomizedTime(timedat, timedat.customizedTime),
            "include": !timedat.alertsOn
          }
        }
        else if (val - 1 == 4) {
          return {
            "customizedDays": { relative_days: timedat.relativeDay },
            "customizedTime": this.handleCustomizedTime(timedat, timedat.customizedTime),
            "include": !timedat.alertsOn
          }
        }
        else {
          return {
            "customizedDays": { days_of_the_week: this.meta.metaDays.slice(0, 5) },
            "customizedTime": this.handleCustomizedTime(timedat, timedat.customizedTime),
            "include": !timedat.alertsOn
          }
        }

    }
  }

  toengineTime(timeDetails: any) {
    if (timeDetails) {
      const timeDivision = { favourites: this.favourites, customizedDays: this.customizedDays }
      for (const key in timeDivision) {
        if (timeDetails[key]) {
          let result = timeDivision[key].handleTime(timeDetails, timeDetails[key])
          if (result) {
            return result;
          }
        }
      }
    } else {
      return null;
    }
  }

  atomicStruct = {
    structureChange(ruleData: any,searchTokens:any[]) {
      const searchtokens = [...searchTokens];
      return searchtokens;
    }
  }

  frequencyStruct = {
    atomicStruct: this.atomicStruct,
    provideTimeWindow(time: number, unit: string) {
      if (time) {
        if (unit == "hours") {
          return time * 60 * 60
        } else {
          return time * 60
        }
      } else {
        return 0
      }

    },
    providepivotFields(fieldsValue: any[]) {
      let arr = []
      if (fieldsValue.length) {
        for (let i = 0; i < fieldsValue.length; i++) {
          arr.push({image:fieldsValue[i][0],cat:"field"})
        }
        return arr
      }
    },

    processpivotFields(fieldsValue) {
      let arr = []
      if (fieldsValue.length) {
        for (let i = 0; i < fieldsValue.length; i++) {
          arr.push(fieldsValue[i][0])
        }
        return arr
      }else {
        return arr
      }
    },

    processaggregatefunction(aggregation:any){
      if(aggregation.aggregateFunction == 'count'){
        return [
          {
            "image": aggregation.aggregateFunction,
            "cat": "function",
            "field": "",
            "alias": aggregation.aggregateFunction
          }
        ]
      }else{
          return [
            {
              "image": aggregation.aggregateFunction,
              "cat": "function",
              "field": aggregation.aggregateFunctionField[0],
              "alias": aggregation.aggregateFunction
            }
          ]
      }
    },

    provideaggregateFunctionField(val: any[] | string) {
      if (typeof (val) == 'string') {
        return val
      } else {
        return val[0]
      }
    },

    structureChange(rule: any,searchtokens:any[]) {
      const aggregation = rule.ruleConditions.aggregationCondition;
      const advancedtokens = [];
      let result = {};
      advancedtokens.push(
      [
        {
          "image": "stats",
          "cat": "command"
        },
        ...this.processaggregatefunction(aggregation),
        {
          "image": "by",
          "cat": "by"
        },
        ...this.providepivotFields(aggregation.pivotFields)
      ],
      [
        {
          "image": "where",
          "cat": "command"
        },
        {
          "image": aggregation.aggregateFunction,
          "cat":"tablecolumn"
        },
        {
          "image": aggregation.thresholdOperator,
          "cat":"operator"
        },
        {
          "image": aggregation.thresholdValue.toString(),
          "cat":"value"
        }
      ]
      )
      result['pivotFields'] = this.processpivotFields(aggregation.pivotFields),
      result['aggregateFunction'] = aggregation.aggregateFunction
      result['aggregateFunctionField'] = this.provideaggregateFunctionField(aggregation.aggregateFunctionField);
      result['thresholdOperator'] = aggregation.thresholdOperator;
      result['thresholdValue'] = aggregation.thresholdValue;
      result['time_window'] = this.provideTimeWindow(aggregation.aggregateTime, aggregation.aggregateTimeUnit);
      return { ...this.atomicStruct.structureChange(rule,searchtokens), aggregation: result,advancedtokens}
    }
  }

  builtinStruct = {
    atomicStruct: this.atomicStruct,
    frequencyStruct:this.frequencyStruct,
    structureChange(rule:any,searchtokens:any[]){
      if(rule.advanced.alertType == "atomic"){
        return {...this.atomicStruct.structureChange(rule,searchtokens)}
      }else{
        return {...this.frequencyStruct.structureChange(rule,searchtokens)}
      }
    }
  }
  structureRuleType = { "standard": this.atomicStruct,"list": this.atomicStruct,"new_term": this.atomicStruct,"atomic": this.atomicStruct, "frequency": this.frequencyStruct, "built_in":this.builtinStruct,"threat_intel": this.atomicStruct,"aggregation": this.atomicStruct}
  toengineQuery(ruleData: any, searchtokens:any) {
    // return this.structureRuleType[ruleData.context.ruleType].structureChange(ruleData,searchtokens)
    return this.structureRuleType[ruleData.ruleConditions.ruleType].structureChange(ruleData,searchtokens)

  }
  
}
